import React, { useState, useCallback } from "react";
import styled from "styled-components";
import NumberFormat from "react-number-format";
import {
  COLUMNS_CXC_CUOTA_ECUENTA,
  COLUMNS_CXC_ECUENTAS,
} from "./DatatableColumns";
import moment from "moment";
import { reactLocalStorage } from "reactjs-localstorage";
import DatatableExpand from "./DatatableExpand";
import DatePicker from "react-datepicker";
import ImageViewer from "react-simple-image-viewer";
import {
  CANCEL_WHITE,
  SAVED_ICON,
  ARROW_LEFT,
  MESSAGE_ICON,
  PENCIL,
  ARROW_RIGHT,
  HORARIO_ICON,
  UPLOAD_PDF,
  LOGO_SCHOOL,
  LOGOUT_ICON,
  UPLOAD_ICON,
  FORUM_ICON,
  SEARCH_FOLDER,
  MORE_ICON,
} from "../../Components/Constants/SrcImages";
import {
  Card,
  CardBody,
  CardText,
  Container,
  Alert,
  Label,
  Row,
  Col,
  Table,
  FormGroup,
  Form,
  Input,
  ListGroup,
  ListGroupItem,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  ButtonGroup,
} from "reactstrap";
import "./../../www/css/style.css";
import ClipLoader from "react-spinners/ClipLoader";
import { css } from "@emotion/core";
import { DirUploadImages } from "./../Constants/Services";
import sha256 from "crypto-js/sha256";
import hmacSHA512 from "crypto-js/hmac-sha512";
import Base64 from "crypto-js/enc-base64";
import { nonce, path, privateKey, urlMultimedia } from "./Services";
const dataHAptitudes = {
  bh_respect: "Respect",
  bh_order_neather: "Order and Neatness",
  bh_respons: "Responsability",
  bh_civism: "Civism",
  bh_honesty: "Honesty",
  bh_coopera: "Cooperation",
  bh_manners: "Manners",
  bh_puntual: "Punctuality",
  bh_selfcont: "Selfcontrol",
};

const override = css`
  margin: 0 auto;
  position: relative;
  top: 10px;
  right: 10px;
`;
const StyledHome = styled.img`
  margin-top: 8px;
  margin: auto;
  height: 60px;
  width: 65px;
  cursor: pointer;
`;

const StyledHomeTeacher = styled.img`
  margin-top: 8px;
  margin: auto;
  height: 105px;
  width: 115px;
  cursor: pointer;
`;

const RadioBtnPayments = styled.label`
  position: relative;
  left: 4px;
  top: 8px;
`;

const LabelUnderline = styled(Label)`
  text-decoration: underline;
  cursor: pointer;
  color: #00f;
`;

const ImageViewerAgenda = ({ ad_img }) => {
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const images = [urlMultimedia + ad_img];
  const images2 = [];
  var i;
  for (i = 0; i < ad_img.length; i++) {
    if (
      ad_img[i].up_file_name.includes(".jpeg") ||
      ad_img[i].up_file_name.includes(".png") ||
      ad_img[i].up_file_name.includes(".jpg")
    ) {
      images2.push(
        urlMultimedia + ad_img[i].not_person + "/" + ad_img[i].up_file_name
      );
    }
  }

  const openImageViewer = useCallback((index, ad_img) => {
    if (ad_img !== "default") {
      setCurrentImage(index);
      setIsViewerOpen(true);
    }
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  return (
    <div className="img-viewer">
      {images.map((src, index) => (
        <img
          src={SEARCH_FOLDER}
          onClick={() => openImageViewer(index, ad_img)}
          className="img-upload-2"
          key={Date.now()}
          alt=""
        />
      ))}

      {isViewerOpen && (
        <ImageViewer
          src={images2}
          currentIndex={currentImage}
          onClose={closeImageViewer}
        />
      )}
    </div>
  );
};

const ImageViewerAnnouncement = ({ ad_img }) => {
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const images = [DirUploadImages + ad_img + ".png"];
  const openImageViewer = useCallback((index, ad_img) => {
    if (ad_img !== "default") {
      setCurrentImage(index);
      setIsViewerOpen(true);
    }
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  return (
    <div>
      {images.map((src, index) => (
        <img
          src={`${src}?${new Date().getSeconds()}`}
          onClick={() => openImageViewer(index, ad_img)}
          width="300"
          className="img-viewer"
          key={Date.now()}
          style={{ margin: "auto" }}
          alt=""
        />
      ))}

      {isViewerOpen && (
        <ImageViewer
          src={images}
          currentIndex={currentImage}
          onClose={closeImageViewer}
        />
      )}
    </div>
  );
};

const TeacherSchedule = ({
  dataTasignature,
  dataGroup,
  dataAsig,
  dataFSchedule,
  setGroup,
  setAsign,
  setTypeAsign,
  setRequireFile,
  onChangeDesc,
  onChangeDatePicker,
  toggleSave,
  toggle,
  msg_error,
  toggleUpload,
  toggleCancelFile,
  file_ramdon_key,
}: any) => {
  const [ddOpenGroup, setDdGroup] = useState(false);
  const toggleDropdownGroup = () => setDdGroup((prevState) => !prevState);
  const [ddOpenGrade, setDdGrade] = useState(false);
  const toggleDropdownGrade = () => setDdGrade((prevState) => !prevState);
  const [ddOpenTipoA, setDdTa] = useState(false);
  const toggleDropdownTipoA = () => setDdTa((prevState) => !prevState);

  var d = new Date();
  return (
    <React.Fragment>
      <Col className="border-schedule-container-teacher mt-3">
        <Row>
          <Col xs={3} className="pl-0 text-left mt-3 d-block d-sm-none">
            <Label className="font-weight-bold">Fecha: </Label>
          </Col>
          {/* MOBILE */}
          <Col
            xs={9}
            className="mt-3 input-schedule-date pm-unset d-block d-sm-none"
          >
            <DatePicker
              className="input-p-relative"
              selected={moment(dataFSchedule.di_date).toDate()}
              onChange={onChangeDatePicker}
              minDate={new Date()}
              maxDate={d.setMonth(d.getMonth() + 8)}
              showDisabledMonthNavigation
            />
          </Col>
          <Col xs={5} sm={1} className="text-left pl-0">
            <Label className="lh-40 font-weight-bold">Grupo: </Label>
          </Col>
          <Col xs={7} sm={2} className="px-0 mx-0">
            <Dropdown
              isOpen={ddOpenGroup}
              toggle={toggleDropdownGroup}
              className="text-center"
            >
              <DropdownToggle className="w-100 column-dark" caret>
                {dataFSchedule.gr_desc
                  ? `${dataFSchedule.gr_desc} (${dataFSchedule.gr_alias})`
                  : "Grupo"}
              </DropdownToggle>
              <DropdownMenu>
                {dataGroup.map((data, i) => (
                  <DropdownItem
                    onClick={() =>
                      setGroup({
                        gr_id: data.gr_id,
                        gr_desc: data.gr_desc,
                        gr_alias: data.gr_alias,
                        fetch: false,
                        ar_literal: data.ar_literal,
                        gr_literal: data.gr_literal,
                      })
                    }
                    key={data.gr_id}
                  >
                    {`${data.gr_desc} (${data.gr_alias})`}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          </Col>

          <React.Fragment>
            {/* DESKTOP */}
            <Col xs={12} sm={9} className="d-none d-sm-block">
              <ButtonGroup>
                <Button
                  outline
                  color="primary"
                  onClick={() =>
                    setTypeAsign({ ta_id: "1", ta_desc: "Recordatorio" })
                  }
                  active={dataFSchedule.ta_id === "1" ? true : false}
                  disabled={dataFSchedule.ar_literal === "1" ? true : false}
                >
                  Recordatorio
                </Button>
                <Button
                  outline
                  color="success"
                  onClick={() =>
                    setTypeAsign({ ta_id: "2", ta_desc: "Formativa" })
                  }
                  active={dataFSchedule.ta_id === "2" ? true : false}
                  disabled={dataFSchedule.ar_literal === "1" ? true : false}
                >
                  Formativa
                </Button>
                <Button
                  outline
                  color="primary"
                  onClick={() =>
                    setTypeAsign({ ta_id: "3", ta_desc: "Apreciacion" })
                  }
                  active={dataFSchedule.ta_id === "3" ? true : false}
                  disabled={dataFSchedule.ar_literal === "1" ? true : false}
                >
                  Apreciacion
                </Button>
                <Button
                  outline
                  color="success"
                  onClick={() =>
                    setTypeAsign({ ta_id: "4", ta_desc: "Sumativa" })
                  }
                  active={dataFSchedule.ta_id === "4" ? true : false}
                  disabled={dataFSchedule.ar_literal === "1" ? true : false}
                >
                  Sumativa
                </Button>
                <Button
                  outline
                  color="success"
                  onClick={() =>
                    setTypeAsign({ ta_id: "5", ta_desc: "Ejercicio" })
                  }
                  active={dataFSchedule.ta_id === "5" ? true : false}
                  disabled={dataFSchedule.ar_literal === "1" ? true : false}
                >
                  Ejercicio
                </Button>
                <Button
                  outline
                  color="danger"
                  onClick={() =>
                    setTypeAsign({ ta_id: "6", ta_desc: "Examen Trimestral" })
                  }
                  active={dataFSchedule.ta_id === "6" ? true : false}
                  disabled={dataFSchedule.ar_literal === "1" ? true : false}
                >
                  Examen trimestral
                </Button>
              </ButtonGroup>
            </Col>
          </React.Fragment>
        </Row>
        {/* MOBILE */}

        <React.Fragment>
          <div className="d-block d-sm-none">
            <Row>
              <Col xs={5} className="text-left pl-0">
                <Label className="lh-40 font-weight-bold">Tipo : </Label>
              </Col>
              <Col xs={7} className="px-0 mx-0">
                <Dropdown
                  isOpen={ddOpenTipoA}
                  toggle={toggleDropdownTipoA}
                  className="text-center"
                  disabled={dataFSchedule.ar_literal === "1" ? true : false}
                >
                  <DropdownToggle className="w-100 column-dark" caret>
                    {dataFSchedule.ta_desc ? dataFSchedule.ta_desc : "Tipo"}
                  </DropdownToggle>
                  <DropdownMenu>
                    {dataTasignature.map((data, i) => (
                      <DropdownItem
                        onClick={() =>
                          setTypeAsign({
                            ta_id: data.ta_id,
                            ta_desc: data.ta_desc,
                          })
                        }
                        key={data.ta_id}
                      >
                        {data.ta_desc}
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </Dropdown>
              </Col>
            </Row>
          </div>
        </React.Fragment>

        <Row className="mt-1">
          <React.Fragment>
            <Col xs={5} sm={1} className="text-left pl-0">
              <Label className="lh-40 font-weight-bold">Materia: </Label>
            </Col>
            <Col xs={7} sm={2} className="px-0 mx-0">
              <Dropdown
                isOpen={ddOpenGrade}
                toggle={toggleDropdownGrade}
                className="text-center"
                disabled={dataFSchedule.ar_literal === "1" ? true : false}
              >
                <DropdownToggle className="w-100 column-dark" caret>
                  {dataFSchedule.as_desc ? dataFSchedule.as_desc : "Materia"}
                </DropdownToggle>
                <DropdownMenu>
                  {dataAsig.map((data, i) => (
                    <DropdownItem
                      onClick={() =>
                        setAsign({ as_id: data.as_id, as_desc: data.as_desc })
                      }
                      key={data.as_id}
                    >
                      {data.as_desc}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
            </Col>
          </React.Fragment>

          <Col xs={12} sm={4} className="pr-0 mt-1 pl-0px">
            <Label className="agenda-label-position font-weight-bold">
              Requiere archivos:
            </Label>
            <ButtonGroup className="float-right btn-agenda-edit">
              <Button
                className="ml-4 warning"
                onClick={() => setRequireFile({ di_alowfile: "1" })}
                active={dataFSchedule.di_alowfile === "1" ? true : false}
              >
                SI
              </Button>
              <Button
                className="ok"
                onClick={() => setRequireFile({ di_alowfile: "0" })}
                active={dataFSchedule.di_alowfile === "0" ? true : false}
              >
                NO
              </Button>
            </ButtonGroup>
          </Col>
          {/* DESKTOP */}
          <Col
            xs={12}
            sm={5}
            className="mt-2 input-date-agenda pr-0 d-none d-sm-block"
          >
            <Label className="mr-2 font-weight-bold">Fecha: </Label>
            <DatePicker
              className="float-center w-100"
              selected={moment(dataFSchedule.di_date).toDate()}
              onChange={onChangeDatePicker}
              minDate={new Date()}
              maxDate={d.setMonth(d.getMonth() + 8)}
              showDisabledMonthNavigation
            />
          </Col>
          <Col xs={12} className="pl-0">
            {file_ramdon_key.length > 0 ? (
              <React.Fragment>
                <Row>
                  <Col xs={3}>
                    <Button className="ok" disabled>
                      Poner archivo multimedia
                    </Button>
                  </Col>
                  <Col xs={1} className="text-left">
                    <img
                      src={LOGOUT_ICON}
                      onClick={() => toggleCancelFile()}
                      className="img-crash-cancel"
                      alt=""
                    />
                  </Col>
                  <Col xs={8}></Col>
                </Row>
              </React.Fragment>
            ) : (
              <Button className="ok" onClick={toggleUpload}>
                Poner archivo multimedia
              </Button>
            )}
          </Col>

          <Col xs={12} sm={12} className="text-left pl-0 mt-2">
            <Label className="font-weight-bold">
              Escriba la descripcion de la asignacion:
            </Label>
          </Col>
          <Col xs={12} className="px-0 mx-0">
            <FormGroup>
              <Input
                type="textarea"
                name="di_desc"
                rows="4"
                onChange={onChangeDesc}
                value={dataFSchedule.di_desc}
                id="di_desc"
                placeholder="Coloque aqui la descripción de la asignación a realizar"
              />
            </FormGroup>
          </Col>
          <Col sm={12} className="text-right">
            {msg_error.length > 0 ? (
              <Label className="l-color-danger">{msg_error}</Label>
            ) : null}
          </Col>
          <Col xs={12} className="text-right px-0 mx-0">
            <Button className="info" onClick={toggleSave}>
              Guardar
            </Button>{" "}
            <Button className="ok" onClick={toggle}>
              Cancelar
            </Button>
          </Col>
        </Row>
      </Col>
    </React.Fragment>
  );
};

const Announcement = (data: any) => {
  const props = data.data;
  return (
    <Alert className="info box-shadow-announcement">
      <Row>
        <Col xs={7} sm={10} className="text-left mb-0">
          <h5 className="font-weight-bold">Anuncio # {props.ad_id}</h5>
        </Col>
        <Col xs={5} sm={2} className="text-center mb-0">
          <Label className="mb-0 font-weight-bold ">
            {moment(props.ad_date).format("MM/DD/YYYY")}
          </Label>
        </Col>
        <Col xs={7} sm={10} className="text-justify mt-0 overflow-auto">
          <hr />
          <p className="mb-0 label-area-desc">{props.ad_desc}</p>
        </Col>
        <Col xs={5} sm={2}>
          <ImageViewerAnnouncement ad_img={props.ad_img} />
        </Col>
      </Row>
    </Alert>
  );
};

const ScheduleTeacherReview = ({
  data,
  dataTa,
  dataFSchedule,
  setTypeAs,
  toggleDelete,
  toggleTypeAsig,
  handleSetEditTypeAsig,
  scheduleSelected,
  toggleAlowFile,
  dataWeekStartEnd,
  setDataWeekStartEnd,
  toggleSendSchedule,
  setFormScheduleNull,
  toggleUpload,
}: any) => {
  const [ddOpenTipoA, setDdTa] = useState(false);
  const toggleDropdownTipoA = () => setDdTa((prevState) => !prevState);
  return (
    <React.Fragment>
      <Col sm={12} className="border-schedule-container-teacher mt-3 mb-5">
        <Row>
          {dataWeekStartEnd[0] !== undefined && (
            <React.Fragment>
              <React.Fragment>
                <Col xs={2} className="p-0 m-0">
                  <StyledHome
                    className="float-left"
                    onClick={() =>
                      setDataWeekStartEnd({
                        date_week_selected:
                          Number(dataFSchedule.date_week_selected) - 1,
                      })
                    }
                    src={ARROW_LEFT}
                    alt=""
                  />
                </Col>
                <Col xs={8} className="text-center p-0 m-0 lh-50px">
                  <Label className="font-weight-bold">
                    {" "}
                    {dataWeekStartEnd[dataFSchedule.date_week_selected].title}
                  </Label>
                </Col>
                <Col xs={2} className=" m-0 p-0">
                  <StyledHome
                    className="float-right"
                    onClick={() =>
                      setDataWeekStartEnd({
                        date_week_selected:
                          Number(dataFSchedule.date_week_selected) + 1,
                      })
                    }
                    src={ARROW_RIGHT}
                    alt=""
                  />
                </Col>
              </React.Fragment>
            </React.Fragment>
          )}
        </Row>
        {data.length > 0 ? (
          <React.Fragment>
            {data.map((data, i) => (
              <Row className="mt-4 margin-2 agenda-font mx-0" key={data.di_id}>
                <Col
                  xs={6}
                  className="border-schedule text-center  column-dark border-rad-l"
                >
                  <Label className="label-agenda-position">{`${data.as_desc.toUpperCase()} (${data.gr_alias.toUpperCase()})`}</Label>
                </Col>
                <Col
                  xs={6}
                  className="border-schedule text-center d-flex  column-dark border-rad-r"
                >
                  <Label className="label-agenda-position-2">
                    {data.di_date.toUpperCase()}
                  </Label>
                  <img
                    src={CANCEL_WHITE}
                    onClick={() => toggleDelete({ di_id: data.di_id })}
                    className="img-crash"
                    alt=""
                  />
                </Col>
                <Col
                  xs={12}
                  className="border-schedule border-schedule-body agenda-font-regular border-schedule-bg"
                >
                  {data.di_desc}
                </Col>
                <Col
                  xs={8}
                  className="border-schedule text-center info hei-50px"
                >
                  <Row>
                    <Col xs={12} sm={6} className="px-0 mx-0 pr-type-asig">
                      {scheduleSelected === data.di_id ? (
                        <React.Fragment>
                          <Dropdown
                            isOpen={ddOpenTipoA}
                            toggle={toggleDropdownTipoA}
                            className="text-center d-flex"
                          >
                            <DropdownToggle className="w-75" caret>
                              {dataFSchedule.ta_desc
                                ? dataFSchedule.ta_desc
                                : "Tipo"}
                            </DropdownToggle>
                            <DropdownMenu>
                              {dataTa.map((dataTas, i) => (
                                <DropdownItem
                                  onClick={() =>
                                    setTypeAs({
                                      di_id: data.di_id,
                                      ta_id: dataTas.ta_id,
                                      ta_desc: dataTas.ta_desc,
                                    })
                                  }
                                  key={dataTas.ta_id}
                                >
                                  {dataTas.ta_desc}
                                </DropdownItem>
                              ))}
                            </DropdownMenu>
                            <img
                              src={LOGOUT_ICON}
                              className="img-pencil-schedule"
                              onClick={() => setFormScheduleNull()}
                              alt=""
                            ></img>
                          </Dropdown>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          {scheduleSelected === "0" ? (
                            <Dropdown
                              isOpen={false}
                              toggle={toggleDropdownTipoA}
                              className="text-center d-flex"
                            >
                              <DropdownToggle
                                className="w-50 column-dark"
                                caret
                              >
                                {data.ta_desc ? data.ta_desc : "Tipo"}
                              </DropdownToggle>
                              <DropdownMenu>
                                {dataTa.map((data, i) => (
                                  <DropdownItem
                                    onClick={() =>
                                      setTypeAs({
                                        di_id: data.di_id,
                                        ta_id: data.ta_id,
                                        ta_desc: data.ta_desc,
                                      })
                                    }
                                    key={data.ta_id}
                                  >
                                    {data.ta_desc}
                                  </DropdownItem>
                                ))}
                              </DropdownMenu>
                              <img
                                src={PENCIL}
                                className="img-pencil-schedule"
                                onClick={() =>
                                  handleSetEditTypeAsig({
                                    scheduleSelected: data.di_id,
                                    di_preescolar: data.di_preescolar,
                                  })
                                }
                                alt=""
                              ></img>
                              <img
                                src={UPLOAD_ICON}
                                className="img-pencil-schedule-upload"
                                onClick={() =>
                                  toggleUpload({
                                    di_id: data.di_id,
                                  })
                                }
                                alt=""
                              ></img>
                              {data.di_file_name.length > 0 ? (
                                <a
                                  className="label-download-file"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  href={
                                    urlMultimedia +
                                    data.di_person +
                                    "/" +
                                    data.di_file_name
                                  }
                                  download
                                >
                                  Ver multimedia
                                </a>
                              ) : null}
                            </Dropdown>
                          ) : (
                            <Dropdown
                              isOpen={false}
                              className="text-center  d-flex"
                              disabled
                            >
                              <DropdownToggle
                                className="w-75 column-dark"
                                caret
                              >
                                {data.ta_desc ? data.ta_desc : "Tipo"}
                              </DropdownToggle>
                              <DropdownMenu>
                                {dataTa.map((data, i) => (
                                  <DropdownItem key={data.ta_id}>
                                    {data.ta_desc}
                                  </DropdownItem>
                                ))}
                              </DropdownMenu>
                            </Dropdown>
                          )}
                        </React.Fragment>
                      )}
                    </Col>
                  </Row>
                </Col>
                <Col
                  xs={4}
                  className="border-schedule text-center m-0 p-0 info hei-50px"
                >
                  <Label className="prela-5p">Requiere archivo</Label>
                  <ButtonGroup className="position-relative-allow-file">
                    <Button
                      className="ml-4 info"
                      onClick={() =>
                        toggleAlowFile({ di_alowfile: "1", di_id: data.di_id })
                      }
                      active={data.di_alowfile === "1" ? true : false}
                    >
                      SI
                    </Button>
                    <Button
                      className="ok"
                      onClick={() =>
                        toggleAlowFile({ di_alowfile: "0", di_id: data.di_id })
                      }
                      active={data.di_alowfile === "0" ? true : false}
                    >
                      NO
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
            ))}
            <Row>
              <Col xs={12} className="text-center">
                <Button
                  className="btn-postion-fixed ok"
                  onClick={toggleSendSchedule}
                >
                  Enviar agendas
                </Button>{" "}
              </Col>
            </Row>
          </React.Fragment>
        ) : (
          <Row>
            <Col xs={12} className="text-center">
              <Label className="font-weight-bold result-none">
                Sin Resultados
              </Label>
            </Col>
          </Row>
        )}
      </Col>
    </React.Fragment>
  );
};

const ScheduleTeacherHistory = ({
  data,
  dataGroup,
  dataWeekStartEnd,
  dataFSchedule,
  setGroup,
  setDataWeekStartEnd,
  per_changeSchedule,
  openModalEdit,
}: any) => {
  const [ddOpenGroup, setDdGroup] = useState(false);
  const toggleDropdownGroup = () => setDdGroup((prevState) => !prevState);
  return (
    <React.Fragment>
      <Col xs={12} className="border-schedule-container-teacher mt-3 mb-5">
        <Row>
          <Col xs={5}>
            <Label className="font-weight-bold schedule-label-group">
              Escoja grupo
            </Label>
          </Col>
          <Col xs={7} className="px-0 mx-0">
            <Dropdown
              isOpen={ddOpenGroup}
              toggle={toggleDropdownGroup}
              className="text-center"
            >
              <DropdownToggle className="w-100 column-dark" caret>
                {dataFSchedule.gr_desc
                  ? `${dataFSchedule.gr_desc} (${dataFSchedule.gr_alias})`
                  : "Grupo"}
              </DropdownToggle>
              <DropdownMenu>
                {dataGroup.map((data, i) => (
                  <DropdownItem
                    className="btn-group-asig"
                    onClick={() =>
                      setGroup({
                        gr_id: data.gr_id,
                        gr_desc: data.gr_desc,
                        gr_alias: data.gr_alias,
                        fetch: true,
                        gr_literal: data.gr_literal,
                      })
                    }
                    key={data.gr_id}
                  >
                    {`${data.gr_desc} (${data.gr_alias})`}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          </Col>
        </Row>
        <Row>
          {dataWeekStartEnd[0] !== undefined && (
            <React.Fragment>
              {dataFSchedule.gr_id.length > 0 ? (
                <React.Fragment>
                  <Col xs={12} className="text-center heigth-10px"></Col>
                  <Col xs={2} className="p-0 m-0">
                    <StyledHome
                      className="float-left"
                      onClick={() =>
                        setDataWeekStartEnd({
                          date_week_selected:
                            Number(dataFSchedule.date_week_selected) - 1,
                        })
                      }
                      src={ARROW_LEFT}
                      alt=""
                    />
                  </Col>
                  <Col xs={8} className="text-center p-0 m-0 lh-50px">
                    <Label className="font-weight-bold">
                      {" "}
                      {dataWeekStartEnd[dataFSchedule.date_week_selected].title}
                    </Label>
                  </Col>
                  <Col xs={2} className=" m-0 p-0">
                    <StyledHome
                      className="float-right"
                      onClick={() =>
                        setDataWeekStartEnd({
                          date_week_selected:
                            Number(dataFSchedule.date_week_selected) + 1,
                        })
                      }
                      src={ARROW_RIGHT}
                      alt=""
                    />
                  </Col>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Col xs={12} className="text-center heigth-10px">
                    <Label className="user-login__error font-weight-bold">
                      Selecciona un grupo
                    </Label>
                  </Col>
                  <Col xs={2} className="p-0 m-0">
                    <StyledHome
                      className="float-left"
                      src={ARROW_LEFT}
                      alt=""
                    />
                  </Col>
                  <Col xs={8} className="text-center p-0 m-0 lh-50px">
                    <Label className="font-weight-bold">
                      {" "}
                      {dataWeekStartEnd[dataFSchedule.date_week_selected].title}
                    </Label>
                  </Col>
                  <Col xs={2} className=" m-0 p-0">
                    <StyledHome
                      className="float-right"
                      src={ARROW_RIGHT}
                      alt=""
                    />
                  </Col>
                </React.Fragment>
              )}
            </React.Fragment>
          )}
        </Row>
        {data.length > 0 ? (
          per_changeSchedule === "1" ? (
            data.map((data, i) => (
              <Row className="mt-4 mx-0 agenda-font" key={data.di_id}>
                <Col
                  xs={6}
                  className="border-schedule text-center column-dark border-rad-l"
                >
                  <Label className="schedule-label-date-grade">{`${data.as_desc.toUpperCase()} (${data.gr_alias.toUpperCase()})`}</Label>
                </Col>
                <Col
                  xs={6}
                  className="border-schedule text-center column-dark border-rad-r "
                >
                  <Label className="schedule-label-date-grade">
                    {data.di_date} ({data.di_id})
                  </Label>
                </Col>
                <Col
                  xs={12}
                  className="border-schedule border-schedule-body agenda-font-regular border-schedule-bg"
                >
                  {data.di_desc}
                </Col>
                {data.di_file_name.length > 0 ? (
                  <React.Fragment>
                    <Col
                      xs={4}
                      className="border-schedule text-center lh-40  info"
                    >
                      <Label className="schedule-type-asig">
                        {data.ta_desc}
                      </Label>
                    </Col>
                    <Col
                      xs={2}
                      className="border-schedule text-center lh-40  info"
                    >
                      <a
                        className="label-download-file"
                        target="_blank"
                        rel="noopener noreferrer"
                        href={
                          urlMultimedia +
                          data.di_person +
                          "/" +
                          data.di_file_name
                        }
                        download
                      >
                        Ver multimedia
                      </a>
                    </Col>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <Col
                      xs={6}
                      className="border-schedule text-center lh-40  info"
                    >
                      <Label className="schedule-type-asig">
                        {data.ta_desc}
                      </Label>
                    </Col>
                  </React.Fragment>
                )}

                <Col
                  xs={6}
                  className="border-schedule text-center m-0 p-0 info"
                >
                  <Label className="schedule-type-asig2">
                    Requiere archivo
                  </Label>
                  <ButtonGroup className="position-relative-allow-file-history btn-agenda-edit">
                    <Button
                      className="ml-4 blue-btn warning"
                      active={data.di_alowfile === "1" ? true : false}
                    >
                      SI
                    </Button>
                    <Button
                      className="red-btn ok"
                      active={data.di_alowfile === "0" ? true : false}
                    >
                      NO
                    </Button>
                  </ButtonGroup>
                  <img
                    src={PENCIL}
                    className="img-pencil"
                    onClick={() => openModalEdit(data)}
                    alt=""
                  ></img>
                </Col>
              </Row>
            ))
          ) : (
            data.map((data, i) => (
              <Row className="mt-4 agenda-font" key={data.di_id}>
                <Col
                  xs={6}
                  className="border-schedule text-center border-rad-l"
                >
                  <Label className="schedule-label-date-grade">{`${data.as_desc} (${data.gr_alias})`}</Label>
                </Col>
                <Col
                  xs={6}
                  className="border-schedule text-center border-rad-r"
                >
                  <Label className="schedule-label-date-grade">
                    {data.di_date} ({data.di_id})
                  </Label>
                </Col>
                <Col
                  xs={12}
                  className="border-schedule border-schedule-body agenda-font-regular border-schedule-bg"
                >
                  {data.di_desc}
                </Col>
                {data.di_file_name.length > 0 ? (
                  <React.Fragment>
                    <Col
                      xs={4}
                      className="border-schedule info text-center lh-40"
                    >
                      <Label className="schedule-type-asig">
                        {data.ta_desc}
                      </Label>
                    </Col>
                    <Col
                      xs={2}
                      className="border-schedule text-center lh-40  info"
                    >
                      <a
                        className="label-download-file-history"
                        target="_blank"
                        rel="noopener noreferrer"
                        href={
                          urlMultimedia +
                          data.di_person +
                          "/" +
                          data.di_file_name
                        }
                        download
                      >
                        Ver multimedia
                      </a>
                    </Col>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <Col
                      xs={6}
                      className="border-schedule info text-center lh-40"
                    >
                      <Label className="schedule-type-asig">
                        {data.ta_desc}
                      </Label>
                    </Col>
                  </React.Fragment>
                )}

                <Col
                  xs={6}
                  className="border-schedule info text-center m-0 p-0"
                >
                  <Label className="schedule-type-asig2">
                    Requiere archivo
                  </Label>
                  <ButtonGroup className="position-relative-allow-file-history">
                    <Button
                      className="ml-4 blue-btn warning"
                      active={data.di_alowfile === "1" ? true : false}
                    >
                      SI
                    </Button>
                    <Button
                      className="red-btn info"
                      active={data.di_alowfile === "0" ? true : false}
                    >
                      NO
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
            ))
          )
        ) : (
          <Row>
            <Col xs={12} className="text-center">
              <Label className="font-weight-bold result-none">
                Sin Resultados
              </Label>
            </Col>
          </Row>
        )}
      </Col>
    </React.Fragment>
  );
};

const SchedulePrint = ({
  data,
  dataNota,
  modalSetPdf,
  per_id,
  rechargeData,
  loading,
  dataWeekStartEnd,
  setDataWeekStartEnd,
  dataFSchedule,
  setRevisado,
}: any) => {
  var exist;
  return (
    <React.Fragment>
      <Col sm={12}>
        <Row>
          <Col sm={12} className="text-center">
            <h4 className="font-weight-bold">Agenda</h4>
          </Col>
        </Row>

        <PaginationHeaderStudentAgenda
          dataWeekStartEnd={dataWeekStartEnd}
          setDataWeekStartEnd={setDataWeekStartEnd}
          dataFSchedule={dataFSchedule}
        />
        {data.length > 0 ? (
          <React.Fragment>
            {data.map((data, i) => {
              exist = dataNota.find(
                (e) => e.di_id === data.di_id && e.not_person === per_id
              );

              return (
                <Row
                  className="mt-4 margin-2 box-shadow-schedule agenda-font mx-0"
                  key={data.di_id}
                >
                  <Col xs={6} sm={7}></Col>
                  <Col
                    xs={6}
                    sm={5}
                    className="text-right border-schedule d-flex column-dark border-rad-r"
                  >
                    <Label className="label-date-schedule font-weight-bold">
                      {data.di_date.toUpperCase()}
                    </Label>
                    <img
                      src={HORARIO_ICON}
                      className="img-calendar-schedule"
                      alt=""
                    />
                  </Col>
                  <Col
                    xs={6}
                    className="border-schedule text-center column-dark"
                  >
                    <Label className="label-date-schedule font-weight-bold">{`${data.as_desc.toUpperCase()} (${data.gr_alias.toUpperCase()})`}</Label>
                  </Col>
                  <Col
                    xs={6}
                    className="border-schedule text-center column-dark"
                  >
                    <Label className="label-date-schedule font-weight-bold">
                      {data.per_name.toUpperCase()}
                    </Label>
                  </Col>
                  <Col
                    xs={12}
                    className="border-schedule border-schedule-body border-schedule-bg"
                  >
                    <Label className="label-date-schedule agenda-font-regular">
                      {data.di_desc}
                    </Label>
                  </Col>

                  {data.di_file_name.length > 0 ? (
                    <React.Fragment>
                      <Col
                        xs={6}
                        className="border-schedule text-center lh-40 info"
                      >
                        <Label className="label-date-schedule">
                          {data.ta_desc}
                        </Label>
                      </Col>
                      <Col
                        xs={6}
                        className="border-schedule text-center lh-40 info"
                      >
                        <a
                          className="label-download-file-student"
                          target="_blank"
                          rel="noopener noreferrer"
                          href={
                            urlMultimedia +
                            data.di_person +
                            "/" +
                            data.di_file_name
                          }
                          download
                        >
                          Multimedia
                        </a>
                      </Col>
                    </React.Fragment>
                  ) : (
                    <Col
                      xs={8}
                      className="border-schedule text-center lh-40 info"
                    >
                      <Label className="label-date-schedule">
                        {data.ta_desc}
                      </Label>
                    </Col>
                  )}
                  <Col
                    xs={4}
                    className="border-schedule text-center m-0 p-0 info"
                  >
                    {exist !== undefined ? (
                      exist.not_file === "1" ? (
                        <img src={SAVED_ICON} className="img-upload" alt="" />
                      ) : data.di_alowfile === "1" ? (
                        <img
                          src={UPLOAD_PDF}
                          onClick={() =>
                            modalSetPdf({
                              di_id: data.di_id,
                              not_id: exist.not_id,
                            })
                          }
                          className="img-upload"
                          alt=""
                        />
                      ) : (
                        //
                        <Button
                          className="warning button-revisado"
                          onClick={() =>
                            setRevisado({
                              di_id: data.di_id,
                              not_person: exist.not_person,
                            })
                          }
                        >
                          Revisado
                        </Button>
                        // <img
                        //   src={CANCEL_UPLOAD}
                        //   className="img-upload"
                        //   alt=""
                        // />
                      )
                    ) : data.di_alowfile === "1" ? (
                      <img
                        src={UPLOAD_PDF}
                        onClick={() =>
                          modalSetPdf({
                            di_id: data.di_id,
                            not_id: exist.not_id,
                          })
                        }
                        className="img-upload"
                        alt="dddd"
                      />
                    ) : (
                      // onClick={() => this.handleModalPassword()
                      <Button
                        className="warning button-revisado"
                        onClick={() =>
                          setRevisado({
                            di_id: data.di_id,
                            not_person: exist.not_person,
                          })
                        }
                      >
                        Revisado
                      </Button>
                      // <img src={CANCEL_UPLOAD} className="img-upload" alt="" />
                    )}
                  </Col>
                  <Col
                    xs={2}
                    className="border-schedule text-center lh-40 info"
                  >
                    <Label className="font-weight-bold label-date-schedule">
                      {exist !== undefined ? exist.not_score: "--"}
                    </Label>
                  </Col>
                </Row>
              );
            })}
          </React.Fragment>
        ) : (
          <Row>
            <Col xs={12} className="text-center">
              <Label className="font-weight-bold result-none">
                Sin Resultados
              </Label>
            </Col>
          </Row>
        )}
      </Col>
    </React.Fragment>
  );
};

const Schedule = ({
  data,
  dataNota,
  modalSetPdf,
  per_id,
  rechargeData,
  loading,
  dataWeekStartEnd,
  setDataWeekStartEnd,
  dataFSchedule,
  setRevisado,
  per_type,
  deleteFile,
  filesObj,
  getFilesNames,
}: any) => {
  var exist;
  return (
    <React.Fragment>
      <Col sm={12} className="border-schedule-container">
        <Row>
          <Col sm={12} className="text-center">
            <h4 className="font-weight-bold">Agenda</h4>
          </Col>
        </Row>

        <PaginationHeaderStudentAgenda
          dataWeekStartEnd={dataWeekStartEnd}
          setDataWeekStartEnd={setDataWeekStartEnd}
          dataFSchedule={dataFSchedule}
        />

        <Row>
          <Col xs={12} className="text-right px-0 mx-0">
            <ClipLoader
              css={override}
              size={23}
              color={"#36D7B7"}
              loading={loading}
            />
            <Button className="mr-2 ok" onClick={() => rechargeData()}>
              Recargar
            </Button>
          </Col>
        </Row>
        {data.length > 0 ? (
          <React.Fragment>
            {data.map((data, i) => {
              exist = dataNota.find(
                (e) => e.di_id === data.di_id && e.not_person === per_id
              );
              return (
                <Row
                  className="mt-4 margin-2 box-shadow-schedule agenda-font mx-0"
                  key={data.di_id}
                >
                  <Col xs={6} sm={7}></Col>
                  <Col
                    xs={6}
                    sm={5}
                    className="text-right border-schedule d-flex column-dark border-rad-r"
                  >
                    <Label className="label-date-schedule font-weight-bold">
                      {data.di_date.toUpperCase()}
                    </Label>
                    <img
                      src={HORARIO_ICON}
                      className="img-calendar-schedule"
                      alt=""
                    />
                  </Col>
                  <Col
                    xs={6}
                    className="border-schedule text-center column-dark"
                  >
                    <Label className="label-date-schedule font-weight-bold">{`${data.as_desc.toUpperCase()} (${data.gr_alias.toUpperCase()})`}</Label>
                  </Col>
                  <Col
                    xs={6}
                    className="border-schedule text-center column-dark"
                  >
                    <Label className="label-date-schedule font-weight-bold">
                      {data.per_name.toUpperCase()}
                    </Label>
                  </Col>
                  <Col
                    xs={12}
                    className="border-schedule border-schedule-body border-schedule-bg"
                  >
                    <Label className="label-date-schedule agenda-font-regular">
                      {data.di_desc}
                    </Label>
                  </Col>

                  {data.di_file_name.length > 0 ? (
                    <React.Fragment>
                      <Col
                        xs={6}
                        className="border-schedule text-center lh-40 info"
                      >
                        <Label className="label-date-schedule">
                          {data.ta_desc}
                        </Label>
                      </Col>
                      <Col
                        xs={6}
                        className="border-schedule text-center lh-40 info"
                      >
                        <a
                          className="label-download-file-student"
                          target="_blank"
                          rel="noopener noreferrer"
                          href={
                            urlMultimedia +
                            data.di_person +
                            "/" +
                            data.di_file_name
                          }
                          download
                        >
                          Multimedia
                        </a>
                      </Col>
                    </React.Fragment>
                  ) : (
                    <Col
                      xs={6}
                      className="border-schedule text-center lh-40 info"
                    >
                      <Label className="label-date-schedule">
                        {data.ta_desc}
                      </Label>
                    </Col>

                  )}
                  <Col
                    xs={6}
                    className="border-schedule text-center m-0 p-0 info "
                  >
                    {exist !== undefined ? (
                      exist.not_file === "1" ? (
                        <div className="d-flex">
                          {data.di_alowfile === "1" ? (
                            <React.Fragment>
                              <img
                                src={SAVED_ICON}
                                className="img-upload"
                                alt=""
                              />
                              <img
                                src={UPLOAD_PDF}
                                onClick={() =>
                                  modalSetPdf({
                                    di_id: data.di_id,
                                    not_id: exist.not_id,
                                  })
                                }
                                className="img-upload"
                                alt=""
                              />
                              <a
                                className={exist.not_up_code}
                                // target="_blank"
                                rel="noopener noreferrer"
                                // href="#"
                                onClick={() =>
                                  getFilesNames({
                                    di_id: data.di_id,
                                    per_id: exist.not_person,
                                  })
                                }
                              >
                                <ImageViewerAgenda ad_img={filesObj} />
                                {/* <img
                                  src={SEARCH_FOLDER}
                                  // onClick={() =>
                                  // modalSetPdf({
                                  //   di_id: data.di_id,
                                  //   not_id: exist.not_id,
                                  // })
                                  // }
                                  className="img-upload-2"
                                  alt=""
                                /> */}
                              </a>

                              <img
                                src={LOGOUT_ICON}
                                onClick={() =>
                                  deleteFile({
                                    di_id: data.di_id,
                                    per_id: exist.not_person,
                                  })
                                }
                                className="img-upload-2"
                                alt=""
                              />
                            </React.Fragment>
                          ) : (
                            <img
                              src={SAVED_ICON}
                              className="img-upload"
                              alt=""
                            />
                          )}
                        </div>
                      ) : data.di_alowfile === "1" ? (
                        <React.Fragment>
                          {per_type === "student" ? (
                            <div className="d-flex">
                              <img
                                src={UPLOAD_PDF}
                                onClick={() =>
                                  modalSetPdf({
                                    di_id: data.di_id,
                                    not_id: exist.not_id,
                                  })
                                }
                                className="img-upload"
                                alt=""
                              />
                            </div>
                          ) : (
                            <img
                              src={UPLOAD_PDF}
                              // onClick={() => modalSetPdf({di_id:data.di_id,not_id:exist.not_id})}
                              className="img-upload"
                              alt=""
                            />
                          )}
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          {per_type === "student" ? (
                            <Button
                              className="warning button-revisado"
                              onClick={() =>
                                setRevisado({
                                  di_id: data.di_id,
                                  not_person: exist.not_person,
                                })
                              }
                            >
                              Revisado
                            </Button>
                          ) : (
                            <Button className="warning button-revisado">
                              Revisado
                            </Button>
                          )}
                        </React.Fragment>
                        //

                        // <img
                        //   src={CANCEL_UPLOAD}
                        //   className="img-upload"
                        //   alt=""
                        // />
                      )
                    ) : data.di_alowfile === "1" ? (
                      // ?????
                      <React.Fragment>
                        {per_type === "student" ? (
                          <React.Fragment>
                            <img
                              src={UPLOAD_PDF}
                              onClick={() =>
                                modalSetPdf({
                                  di_id: data.di_id,
                                  not_id: exist.not_id,
                                })
                              }
                              className="img-upload"
                              alt="dddd"
                            />
                          </React.Fragment>
                        ) : (
                          <img
                            src={UPLOAD_PDF}
                            // onClick={() => modalSetPdf({di_id:data.di_id,not_id:exist.not_id})}
                            className="img-upload"
                            alt="dddd"
                          />
                        )}
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        {per_type === "student" ? (
                          <Button
                            className="warning button-revisado"
                            onClick={() =>
                              setRevisado({
                                di_id: data.di_id,
                                not_person: exist.not_person,
                              })
                            }
                          >
                            Revisado
                          </Button>
                        ) : (
                          <Button className="warning button-revisado">
                            Revisado
                          </Button>
                        )}
                      </React.Fragment>
                      // onClick={() => this.handleModalPassword()

                      // <img src={CANCEL_UPLOAD} className="img-upload" alt="" />
                    )}
                  </Col>
                  <Col
                    xs={6}
                    className="border-schedule text-center lh-40 info"
                  >
                    <Label className="font-weight-bold label-date-schedule">
                      {exist !== undefined ? exist.not_score: "--"}
                    </Label>
                  </Col>
                  
                </Row>
              );
            })}
          </React.Fragment>
        ) : (
          <Row>
            <Col xs={12} className="text-center">
              <Label className="font-weight-bold result-none">
                Sin Resultados
              </Label>
            </Col>
          </Row>
        )}
      </Col>
    </React.Fragment>
  );
};

const Messagess = () => (
  <React.Fragment>
    <Container className="mt-4 p-5">
      <Row>
        <Col sm={4} className="text-center">
          <Row>
            <Label>Docentes 5to</Label>
          </Row>
          <Row>
            <Label>Profesor Fuentes</Label>
          </Row>
          <Row>
            <Label>Profesor Rodriguez</Label>
          </Row>
          <Row>
            <Label>Profesora Estela</Label>
          </Row>
        </Col>
        <Col sm={8} className="text-center">
          <Row>
            <Label>Profesor Fuentes</Label>
          </Row>
          <Row>
            <Label></Label>
          </Row>
          <Row>
            <Label></Label>
          </Row>
        </Col>
      </Row>
    </Container>
  </React.Fragment>
);

const ProfilePanelTeacher = ({
  props,
  handleModalEmail,
  handleModalAvatar,
  handleModalCellphone,
  AVATAR,
}: any) => {
  return (
    <Row>
      <Col sm={3} className="text-center mb-2">
        <StyledHomeTeacher
          key={Date.now()}
          width="100%"
          src={`${AVATAR}?${new Date().getSeconds()}`}
          alt=""
          onClick={() => handleModalAvatar()}
        ></StyledHomeTeacher>
      </Col>
      <Col sm={6}>
        <Card className="">
          <CardBody>
            <CardText>
              <Label className="font-weight-bold">
                {props.per_name} {props.per_lastname}{" "}
              </Label>
              <br></br>
              <Label className="font-weight-bold">Consejeria : &nbsp;</Label>
              {`${props.gr_desc} (${props.gr_alias})`}
              <br></br>
              <Label className="font-weight-bold">Correo : &nbsp;</Label>
              <LabelUnderline
                className="LabelUnderline"
                onClick={() => handleModalEmail()}
              >
                {props.per_email}
              </LabelUnderline>{" "}
              <img
                src={PENCIL}
                className="img-pencil"
                onClick={() => handleModalEmail()}
                alt=""
              ></img>
              <br></br>
              <Label className="font-weight-bold">Celular : &nbsp;</Label>
              <LabelUnderline
                className="LabelUnderline"
                onClick={() => handleModalCellphone()}
              >
                {`${props.per_celphone1}`}
              </LabelUnderline>{" "}
              <img
                src={PENCIL}
                className="img-pencil"
                onClick={() => handleModalCellphone()}
                alt=""
              ></img>
            </CardText>
          </CardBody>
        </Card>
      </Col>
      <Col sm={3} className="text-center mb-2">
        <Row>
          <Col sm={12} className="text-center">
            <StyledHomeTeacher
              width="100%"
              src={LOGO_SCHOOL}
              alt=""
            ></StyledHomeTeacher>
            <Label className="font-weight-bold mt-3">
              {props.grc_trimestre} Trimestre
            </Label>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

const ProfilePanel = ({
  propsStdudent,
  propsAcud,
  handleModalEmail,
  handleModalAvatar,
  STD_AVATAR,
  ACU_AVATAR,
  loading,
}: any) => {
  return (
    <Row>
      <Col sm={5} className="text-center mt-2">
        <Card className="pt-2 min-h225 box-shadow-profile">
          <StyledHome
            key={Date.now()}
            width="100%"
            src={`${STD_AVATAR}?${new Date().getSeconds()}`}
            alt=""
            onClick={() => handleModalAvatar("STD")}
          ></StyledHome>
          <CardBody>
            <CardText>
              <Label className="font-weight-bold">
                {propsStdudent.per_name} {propsStdudent.per_lastname}{" "}
              </Label>
              <br></br>
              {propsStdudent.per_cedula}
              <br></br>
              {propsStdudent.gr_desc}
              <br></br>
              <LabelUnderline
                className="LabelUnderline"
                onClick={() => handleModalEmail()}
              >
                {propsStdudent.per_email}
              </LabelUnderline>{" "}
              <img
                src={PENCIL}
                className="img-pencil"
                onClick={() => handleModalEmail()}
                alt=""
              ></img>
            </CardText>
          </CardBody>
        </Card>
      </Col>
      <Col sm={2}></Col>
      <Col sm={5} className="text-center  mt-2">
        <Card className="pt-2 min-h225 box-shadow-profile">
          <StyledHome
            key={Date.now()}
            width="100%"
            src={`${ACU_AVATAR}?${new Date().getSeconds()}`}
            alt=""
            onClick={() => handleModalAvatar("ACU")}
          ></StyledHome>
          <CardBody>
            <CardText>
              <Label className="font-weight-bold">
                {propsAcud.per_name} {propsAcud.per_lastname}
              </Label>
              <br></br>
              {propsAcud.per_cedula}
              <br></br>
              Acudiente
              <br></br>
              {propsAcud.per_celphones}
            </CardText>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

const PaginationHeader = ({ trimestre, arrow_handler }) => (
  <Row className="justify-content-center align-items-center">
    <Col xs="auto">
      <StyledHome
        src={ARROW_LEFT}
        alt=""
        onClick={() => arrow_handler({ trimestre, operation: "left" })}
      />
    </Col>
    <Col className="text-center">
      <Label className="mb-0 font-weight-bold">{trimestre} Trimestre</Label>
    </Col>
    <Col xs="auto">
      <StyledHome
        src={ARROW_RIGHT}
        alt=""
        onClick={() => arrow_handler({ trimestre, operation: "right" })}
      />
    </Col>
  </Row>
);

const PaginationHeaderStudentAgenda = ({
  dataWeekStartEnd,
  setDataWeekStartEnd,
  dataFSchedule,
}) => {
  return (
    <Row className="justify-content-center align-items-center">
      <React.Fragment>
        <Col xs={12} className="text-center heigth-10px"></Col>
        <Col xs={2} className="p-0 m-0">
          <StyledHome
            className="float-left"
            onClick={() =>
              setDataWeekStartEnd({
                date_week_selected:
                  Number(dataFSchedule.date_week_selected) - 1,
              })
            }
            src={ARROW_LEFT}
            alt=""
          />
        </Col>
        <Col xs={8} className="text-center p-0 m-0 lh-50px">
          <Label className="font-weight-bold">
            {" "}
            {dataWeekStartEnd[dataFSchedule.date_week_selected] !== undefined
              ? dataWeekStartEnd[dataFSchedule.date_week_selected].title
              : ""}
          </Label>
        </Col>
        <Col xs={2} className=" m-0 p-0">
          <StyledHome
            className="float-right"
            onClick={() =>
              setDataWeekStartEnd({
                date_week_selected:
                  Number(dataFSchedule.date_week_selected) + 1,
              })
            }
            src={ARROW_RIGHT}
            alt=""
          />
        </Col>
      </React.Fragment>
    </Row>
  );
};

const PaginationHeaderYear = ({ year, changeHeader }: any) => (
  <Row className="justify-content-center align-items-center">
    <Col sm={5} className="text-right">
      <StyledHome
        src={ARROW_LEFT}
        alt=""
        onClick={() => changeHeader({ year, operation: "left" })}
      />
    </Col>
    <Col sm={2} className="text-center">
      <Label className="mb-0">{year}</Label>
    </Col>
    <Col sm={5} className="text-left">
      <StyledHome
        src={ARROW_RIGHT}
        alt=""
        onClick={() => changeHeader({ year, operation: "right" })}
      />
    </Col>
  </Row>
);

const Payment = (onChange: any) => (
  <React.Fragment>
    <Container>
      <Row>
        <Col sm={12} className="text-center">
          <Label className="font-weight-bold">Pagos y cuentas</Label>
        </Col>
        <Col sm={4}>
          <Form>
            <FormGroup>
              <Label for="name">Matricula</Label>
              <Input
                type="text"
                name="matricula"
                defaultValue=""
                id="matricula"
                placeholder="Matricula"
                disabled
              />
            </FormGroup>
          </Form>
        </Col>
        <Col sm={4}></Col>
        <Col sm={4}>
          <Form>
            <FormGroup>
              <Label for="name">Fecha de pago</Label>
              <Input
                type="text"
                name="paymentDate"
                defaultValue=""
                id="paymentDate"
                placeholder="dd/mm/yyyy"
                disabled
              />
            </FormGroup>
          </Form>
        </Col>
        <Col sm={12}>
          <Table bordered>
            <thead>
              <tr>
                <th>Cuota de colegiatura</th>
                <th>Plataforma</th>
                <th>Laboratorio</th>
                <th>Educ. Fisica</th>
                <th>Fecha de pago</th>
                <th>Recargo por morosidad 10%</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div className="radio d-flex">
                    <Input
                      type="text"
                      name="paymentDate"
                      defaultValue=""
                      id="paymentDate"
                      placeholder="B/."
                      disabled
                    />
                    <RadioBtnPayments>
                      <input type="radio" value="option3" />
                    </RadioBtnPayments>
                  </div>
                </td>
                <td>
                  <div className="radio d-flex">
                    <Input
                      type="text"
                      name="paymentDate"
                      defaultValue=""
                      id="paymentDate"
                      placeholder="B/."
                      disabled
                    />
                    <RadioBtnPayments>
                      <input type="radio" value="option3" />
                    </RadioBtnPayments>
                  </div>
                </td>
                <td>
                  <div className="radio d-flex">
                    <Input
                      type="text"
                      name="paymentDate"
                      defaultValue=""
                      id="paymentDate"
                      placeholder="B/."
                      disabled
                    />
                    <RadioBtnPayments>
                      <input type="radio" value="option3" />
                    </RadioBtnPayments>
                  </div>
                </td>
                <td>
                  <div className="radio d-flex">
                    <Input
                      type="text"
                      name="paymentDate"
                      defaultValue=""
                      id="paymentDate"
                      placeholder="B/."
                      disabled
                    />
                    <RadioBtnPayments>
                      <input type="radio" value="option3" />
                    </RadioBtnPayments>
                  </div>
                </td>
                <td>
                  <Input
                    type="text"
                    name="paymentDate"
                    defaultValue=""
                    id="paymentDate"
                    placeholder="dd/mm/yyyy"
                    disabled
                  />
                </td>
                <td>
                  {" "}
                  <div className="radio d-flex">
                    <Input
                      type="text"
                      name="paymentDate"
                      defaultValue=""
                      id="paymentDate"
                      placeholder="B/."
                      disabled
                    />
                    <RadioBtnPayments>
                      <input type="radio" value="option3" />
                    </RadioBtnPayments>
                  </div>
                </td>
              </tr>
            </tbody>
          </Table>
        </Col>
        <Col sm={4}>
          <Form>
            <FormGroup>
              <Label for="name">Anualidad</Label>
              <Input
                type="text"
                name="matricula"
                defaultValue=""
                id="matricula"
                placeholder="Matricula"
                disabled
              />
            </FormGroup>
          </Form>
        </Col>
        <Col sm={4}></Col>
        <Col sm={4}>
          <Form>
            <FormGroup>
              <Label for="name">Saldo de colegiatura</Label>
              <Input
                type="text"
                name="paymentDate"
                defaultValue=""
                id="paymentDate"
                placeholder="dd/mm/yyyy"
                disabled
              />
            </FormGroup>
          </Form>
        </Col>
      </Row>
    </Container>
  </React.Fragment>
);

const ordenarAsc = (p_array_json, p_key) => {
  return p_array_json.sort(function (a, b) {
    return a[p_key] > b[p_key];
  });
};

const Ratings = ({
  dataNote,
  setNoteDesc,
  formNoteDesc,
  formNoteComment,
  see_prom
}: any) => {
  var hashArea = {};
  var area = [];
  area = dataNote.filter((o) =>
    hashArea[o.ar_id] || o.as_id === null ? false : (hashArea[o.ar_id] = true)
  );

  var asignature = {};
  dataNote.map((data, i) => {
    if (data.not_preescolar === "1") {
      if (asignature[data.as_id]) {
        asignature[data.as_id].push({
          ar_id: data.ar_id,
          not_score: data.not_score,
          di_desc: data.di_desc,
          as_desc: data.as_desc,
          di_typeassignment: data.di_typeassignment,
          not_comment: data.not_comment,
          di_id: data.not_agenda,
        });
      } else {
        asignature = {
          ...asignature,
          [data.as_id]: [
            {
              ar_id: data.ar_id,
              not_score: data.not_score,
              di_desc: data.di_desc,
              as_desc: data.as_desc,
              di_typeassignment: data.di_typeassignment,
              not_comment: data.not_comment,
              di_id: data.not_agenda,
            },
          ],
        };
      }
    } else {
      if (asignature[data.as_id]) {
        asignature[data.as_id].push({
          not_score: parseFloat(data.not_score).toFixed(1),
          di_desc: data.di_desc,
          as_desc: data.as_desc,
          di_typeassignment: data.di_typeassignment,
          not_comment: data.not_comment,
          di_id: data.not_agenda,
          gr_literal:data.gr_literal,
          gr_prom_d:data.gr_prom_d
        });
      } else {
        asignature = {
          ...asignature,
          [data.as_id]: [
            {
              not_score: parseFloat(data.not_score).toFixed(1),
              di_desc: data.di_desc,
              as_desc: data.as_desc,
              di_typeassignment: data.di_typeassignment,
              not_comment: data.not_comment,
              di_id: data.not_agenda,
              gr_literal:data.gr_literal,
              gr_prom_d:data.gr_prom_d
            },
          ],
        };
      }
    }

    return null;
  });
  return (
    <React.Fragment>
      <Row>
        {dataNote.length > 0 ? (
          area.length > 0 ? (
            <React.Fragment>
              <Col xs={12} className="text-center overflow-auto table-libreta">
                <Table bordered id="table-rating" className="border-uns">
                  <thead></thead>
                  <tbody>
                    {area.map(function (dataA, i) {
                      return (
                        <React.Fragment key={i}>
 <tr><th className="border-uns">
 <Label key={i} className="font-weight-bold label-area">
                            {dataA.ar_desc}
                            </Label>
   </th></tr>
 
  

                          {Object.keys(asignature).map(function (key, i) {
                            var prom = 0;
                            var promCount = 0;
                            return (
                              <React.Fragment key={i}>
                                <tr key={i + i}>
                                  {/* </th> */}
                                  {dataA.ar_id === asignature[key][0].ar_id && (
                                    <React.Fragment>
                                      <th
                                        scope="row"
                                        className="w-250px column-dark padd-2px text-left"
                                      >
                                        {asignature[key][0].as_desc}
                                      </th>
                                    </React.Fragment>
                                  )}
                                  <React.Fragment key={i}>

                                      {asignature[key][0].gr_literal === "0" ? (
                                        see_prom ?                                       <React.Fragment>
                                        {asignature[key][0].gr_prom_d ===
                                        "1" ? (
                                          <th
                                          key={i}
                                          className="alert-success padd-2px text-center w-50px"
                                        >

                                          <Label>
                                           {GET_PROMF_DIVIDIDO(
                                              asignature[key]
                                            )}
                                          </Label>
                                          </th>
                                        ) : (
                                          <th
                                          key={i}
                                          className="alert-success padd-2px text-center w-50px"
                                        >
                                          <Label>
                                           {GET_PROMF_NORMAL(
                                              asignature[key],
                                              dataA
                                            )}
                                          </Label>
                                          </th>
                                        )}
                                      </React.Fragment>: null
 
                                      ) : null}
                                    
                                  </React.Fragment>
                                  {asignature[key].map((data, i) => {
                                    if (
                                      dataA.ar_id === data.ar_id &&
                                      asignature[key][0].as_id === data.as_id
                                    ) {
                                      return (
                                        <React.Fragment key={i}>
                                          <th
                                            key={i}
                                            onClick={() =>
                                              setNoteDesc({
                                                di_desc: data.di_desc,
                                                not_comment: data.not_comment,
                                              })
                                            }
                                            className={
                                              data.di_typeassignment === "3"
                                                ? "w-50px info padd-2px"
                                                : data.di_typeassignment === "6"
                                                ? "w-50px warning padd-2px"
                                                : "w-50px ok padd-2px"
                                            }
                                          >
                                            {data.not_score}
                                          </th>
                                          <th className="border-uns"></th>
                                        </React.Fragment>
                                      );
                                    }
                                    return null;
                                  })}
                                </tr>
                              </React.Fragment>
                            );
                          })}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </Table>
              </Col>
              <Col xs={12}>
                <FormGroup>
                  <Label className="font-weight-bold">Descripción:</Label>
                  <Input
                    type="textarea"
                    rows="5"
                    name="di_desc"
                    defaultValue={formNoteDesc}
                    id="di_desc"
                    placeholder="Descripción"
                    disabled
                  />
                </FormGroup>
                {formNoteComment.length > 0 ? (
                  <FormGroup>
                    <Label className="font-weight-bold">Comentario:</Label>
                    <Input
                      type="textarea"
                      rows="5"
                      name="not_comment"
                      defaultValue={formNoteComment}
                      id="not_comment"
                      placeholder="Comentario"
                      disabled
                    />
                  </FormGroup>
                ) : null}
              </Col>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <Col xs={12} className="text-center overflow-auto table-libreta">
                <Table bordered id="table-rating">
                  <thead></thead>
                  <tbody>
                    {Object.keys(asignature).map(function (key, i) {
                      return (
                        <tr key={i}>
                          <th
                            scope="row"
                            className="w-250px column-dark padd-2px"
                          >
                            {asignature[key][0].as_desc}
                          </th>
                          {asignature[key].map((data, i) => (
                            <th
                              key={i}
                              onClick={() =>
                                setNoteDesc({
                                  di_desc: data.di_desc,
                                  not_comment: data.not_comment,
                                })
                              }
                              className={
                                data.di_typeassignment === "3"
                                  ? "info padd-2px"
                                  : data.di_typeassignment === "6"
                                  ? "warning padd-2px"
                                  : "ok padd-2px"
                              }
                            >
                              {data.not_score}
                            </th>
                          ))}
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Col>
              <Col xs={12}>
                <FormGroup>
                  <Label className="font-weight-bold">Descripción:</Label>
                  <Input
                    type="textarea"
                    rows="5"
                    name="di_desc"
                    defaultValue={formNoteDesc}
                    id="di_desc"
                    placeholder="Descripción"
                    disabled
                  />
                </FormGroup>
                {formNoteComment.length > 0 ? (
                  <FormGroup>
                    <Label className="font-weight-bold">Comentario:</Label>
                    <Input
                      type="textarea"
                      rows="5"
                      name="not_comment"
                      defaultValue={formNoteComment}
                      id="not_comment"
                      placeholder="Comentario"
                      disabled
                    />
                  </FormGroup>
                ) : null}
              </Col>
            </React.Fragment>
          )
        ) : (
          <Col className="text-center p-0" xs={12}>
            <Label className="font-weight-bold result-none">
              Sin Resultados
            </Label>
          </Col>
        )}
      </Row>
    </React.Fragment>
  );
};

const HOUR_CLASS = ({ dataHour, type, onPrint }: any) => (
  <React.Fragment>
    <Row>
      <Col xs={12} className="text-center">
        <h4 className="font-weight-bold">Horario</h4>
      </Col>
      <Col xs={12} className="text-right">
        <Button className="ok" onClick={() => onPrint({ type, dataHour })}>
          Imprimir
        </Button>
      </Col>
      <Col xs={12} className="text-center overflow-auto table-hour mt-4">
        <Table bordered className="m-auto table-libreta">
          <thead>
            <tr>
              <th>
                <Label className="label-area-desc"> HORA</Label>
              </th>
              <th>
                <Label className="label-area-desc"> LUNES</Label>
              </th>
              <th>
                <Label className="label-area-desc"> MARTES</Label>
              </th>
              <th>
                <Label className="label-area-desc"> MIERCOLES</Label>
              </th>
              <th>
                <Label className="label-area-desc"> JUEVES</Label>
              </th>
              <th>
                <Label className="label-area-desc"> VIERNES</Label>
              </th>
            </tr>
          </thead>
          <tbody>
            {type === "teacher"
              ? dataHour.map((data, i) => (
                  <tr key={i}>
                    <th scope="row" className="w-body-hour column-dark">
                      {" "}
                      <Label className="label-area-desc">{`${moment(
                        data.tas_hourstar
                      ).format("hh:mm")} - ${moment(data.tas_hourend).format(
                        "hh:mm"
                      )}`}</Label>{" "}
                    </th>
                    <th>
                      {" "}
                      <Label className="label-area-desc">
                        {" "}
                        {data.grdesc_lunes !== null ||
                        data.asdesc_lunes !== null
                          ? `${data.grdesc_lunes} - ${data.asdesc_lunes} `
                          : null}
                      </Label>{" "}
                    </th>
                    <th>
                      <Label className="label-area-desc">
                        {" "}
                        {data.grdesc_martes !== null ||
                        data.asdesc_martes !== null
                          ? `${data.grdesc_martes} - ${data.asdesc_martes} `
                          : null}
                      </Label>
                    </th>
                    <th>
                      <Label className="label-area-desc">
                        {" "}
                        {data.grdesc_miercoles !== null ||
                        data.asdesc_miercoles !== null
                          ? `${data.grdesc_miercoles} - ${data.asdesc_miercoles} `
                          : null}
                      </Label>
                    </th>
                    <th>
                      <Label className="label-area-desc">
                        {" "}
                        {data.grdesc_jueves !== null ||
                        data.asdesc_jueves !== null
                          ? `${data.grdesc_jueves} - ${data.asdesc_jueves} `
                          : null}
                      </Label>
                    </th>
                    <th>
                      <Label className="label-area-desc">
                        {" "}
                        {data.grdesc_viernes !== null ||
                        data.asdesc_viernes !== null
                          ? `${data.grdesc_viernes} - ${data.asdesc_viernes} `
                          : null}
                      </Label>
                    </th>
                  </tr>
                ))
              : dataHour.map((data, i) => (
                  <tr key={i}>
                    <th
                      scope="row"
                      className="w-body-hour column-dark"
                    >{`${moment(data.hr_hourstart).format("hh:mm")} - ${moment(
                      data.hr_hourend
                    ).format("hh:mm")}`}</th>
                    <th>
                      <Label className="label-area-desc">
                        {" "}
                        {data.asdesc_lunes}
                      </Label>
                    </th>
                    <th>
                      <Label className="label-area-desc">
                        {" "}
                        {data.asdesc_martes}
                      </Label>
                    </th>
                    <th>
                      <Label className="label-area-desc">
                        {" "}
                        {data.asdesc_miercoles}
                      </Label>
                    </th>
                    <th>
                      <Label className="label-area-desc">
                        {" "}
                        {data.asdesc_jueves}
                      </Label>
                    </th>
                    <th>
                      <Label className="label-area-desc">
                        {" "}
                        {data.asdesc_viernes}
                      </Label>
                    </th>
                  </tr>
                ))}
          </tbody>
        </Table>
      </Col>
      {type === "teacher" ? (
        <Col xs={12} className="text-center mt-4">
          <FormGroup>
            <Label className="font-weight-bold">Link personal:</Label>
            <Input
              type="text"
              name="per_link"
              rows="1"
              defaultValue={dataHour[0].per_link}
              id="per_link"
              disabled
            />
          </FormGroup>
        </Col>
      ) : null}
    </Row>
  </React.Fragment>
);

const MESSAGE_PERSON_LIST = ({
  props,
  setPerson,
  setPersonForum,
  handlerGoback,
  isBack,
}: any) => {
  return (
    <React.Fragment>
      <Row>
        {isBack && (
          <Col xs={12} className="text-right">
            <Button className="ok" onClick={() => handlerGoback()}>
              Regresar
            </Button>
          </Col>
        )}
        <Col xs={12} className="text-center mt-2">
          {props.formGrade !== undefined ? (
            <Label className="font-weight-bold">{`${props.formGrade.gr_desc} ${props.formGrade.gr_alias}`}</Label>
          ) : null}
        </Col>
        {props.dataPerson.length > 0 ? (
          <Col xs={12} className="text-left mt-3">
            <ListGroup className="overflow-auto oheight">
              <ListGroupItem
                className="d-flex lh-40 foro-grupal"
                tag="a"
                action
                onClick={() => setPersonForum()}
              >
                <img className="list-person-icon" src={FORUM_ICON} alt="" />
                <Label className="ml-3 label-area-desc-bold cursor-pointer">
                  FORO GRUPAL
                </Label>
              </ListGroupItem>
              {props.dataPerson.map((index, i) => (
                <ListGroupItem
                  className="d-flex lh-40"
                  key={index.per_id}
                  tag="a"
                  action
                  onClick={() =>
                    setPerson({
                      per_id: index.per_id,
                      per_name: index.per_name,
                    })
                  }
                >
                  <img className="list-person-icon" src={MESSAGE_ICON} alt="" />
                  <Label className="ml-3 label-area-desc-bold">
                    {index.per_name}
                  </Label>
                  {index.count !== "0" ? (
                    <Label className="ml-3 count-msg">{index.count}</Label>
                  ) : null}
                </ListGroupItem>
              ))}
            </ListGroup>
          </Col>
        ) : (
          <React.Fragment>
            <Col className="text-center mb-1 p-0" xs={12}>
              <img className="icon-msg" src={MESSAGE_ICON} alt="" />
            </Col>
            <Col className="text-center p-0" xs={12}>
              <Label className="font-weight-bold result-none">
                Sin Resultados
              </Label>
            </Col>
          </React.Fragment>
        )}
      </Row>
    </React.Fragment>
  );
};

const MESSAGE_PERSON_LIST_FORUM = ({
  props,
  setPerson,
  setPersonForum,
  handlerGoback,
  isBack,
}: any) => {
  return (
    <React.Fragment>
      <Row>
        {isBack && (
          <Col xs={12} className="text-right">
            <Button className="ok" onClick={() => handlerGoback()}>
              Regresar
            </Button>
          </Col>
        )}
        <Col xs={12} className="text-center mt-2">
          {props.formGrade !== undefined ? (
            <Label className="font-weight-bold">{`${props.formGrade.gr_desc} ${props.formGrade.gr_alias}`}</Label>
          ) : null}
        </Col>
        {props.dataPerson.length > 0 ? (
          <Col xs={12} className="text-left mt-3">
            <ListGroup className="overflow-auto oheight">
              {props.dataPerson.map((index, i) => (
                <ListGroupItem
                  className="d-flex lh-40  foro-grupal"
                  key={index.per_id}
                  tag="a"
                  action
                  onClick={() =>
                    setPersonForum({
                      per_id: index.per_id,
                      per_name: index.per_name,
                    })
                  }
                >
                  <img className="list-person-icon" src={FORUM_ICON} alt="" />
                  <Label className="ml-3 label-area-desc-bold">
                    {index.per_name}
                  </Label>
                  {index.count !== "0" ? (
                    null
                    // <Label className="ml-3 count-msg">{index.count}</Label>
                  ) : null}
                </ListGroupItem>
              ))}
            </ListGroup>
          </Col>
        ) : (
          <React.Fragment>
            <Col className="text-center mb-1 p-0" xs={12}>
              <img className="icon-msg" src={MESSAGE_ICON} alt="" />
            </Col>
            <Col className="text-center p-0" xs={12}>
              <Label className="font-weight-bold result-none">
                Sin Resultados
              </Label>
            </Col>
          </React.Fragment>
        )}
      </Row>
    </React.Fragment>
  );
};

const MESSAGE_CHAT_INTERFACE = ({
  per_person,
  props,
  handlerSendMessage,
  onChangeMessage,
  isOpenMessage,
  handlerGoback,
  isOpenButtonback,
  reload,
}: any) => {

  return (
    <React.Fragment>
      {isOpenButtonback && (
        <Col xs={12} className="text-right mb-4 p-0 d-block d-sm-none">
          <ClipLoader
            css={override}
            size={23}
            color={"#36D7B7"}
            loading={props.loading}
          />
          <Button className="mr-2 ok" onClick={() => reload()}>
            Recargar
          </Button>
          <Button className="info" onClick={() => handlerGoback()}>
            Cerrar
          </Button>
        </Col>
      )}
      {props.isOpenMessage ? (
        props.personForm.per_name.length > 0 && (
          <React.Fragment>
            <Col xs={12} className="text-right mb-4 p-0 d-none d-sm-block">
              <ClipLoader
                css={override}
                size={23}
                color={"#36D7B7"}
                loading={props.loading}
              />
              <Button className="mr-2 info" onClick={() => reload()}>
                Recargar
              </Button>
              <Button className="ok" onClick={() => handlerGoback()}>
                Cerrar
              </Button>
            </Col>
            <div
              className="p-0 chat-window col-xs-12 col-md-12"
              id="chat_window_1"
            >
              <div className="panel panel-default">
                <div className={"panel-heading  " + (props.isOpenForum ? 'foro-grupal2' : 'top-bar')}>
                  <div className="col-md-12 col-xs-12">
                    <label className="panel-title d-flex">
                      <span className="glyphicon glyphicon-comment"></span>{" "}
                      <img
                        className="icon-msg-chat"
                        src={MESSAGE_ICON}
                        alt=""
                      />
                      Chat - {props.personForm.per_name}
                    </label>
                  </div>
                </div>
                <div
                  className="panel-body msg_container_base"
                  id="scrollContainer"
                >
                  {props.dataMessages.map((data, i) =>
                    data.per_id === per_person ? (
                      <div className="row msg_container base_sent" key={i}>
                        <div className="col-2"></div>
                        <div className="col-8">
                          <div className="messages msg_sent">
                            <p className="label-name-chat">{data.per_name}</p>
                            <p className="pl-2">{data.msg_desc}</p>
                            <time dateTime="2009-11-13T20:00">
                              {moment(data.msg_time).format("YYYY-MM-DD HH:mm")}
                            </time>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="row msg_container base_receive" key={i}>
                        <div className="col-8">
                          <div className="messages msg_receive">
                            <p
                              className="label-name-chat"
                              style={{ color: "cornflowerblue" }}
                            >
                              {data.per_name}
                            </p>
                            <p className="pl-2">{data.msg_desc}</p>
                            <time dateTime="2009-11-13T20:00">
                              {moment(data.msg_time).format("YYYY-MM-DD hh:mm")}
                            </time>
                          </div>
                        </div>
                        <div className="col-2"></div>
                      </div>
                    )
                  )}
                </div>
                <div className="panel-footer">
                  <div className="input-group">
                    <input
                      type="text"
                      name="msg_desc"
                      onChange={onChangeMessage}
                      value={props.formMessages.msg_desc}
                      // id="msg_desc"
                      className="form-control input-sm rounded-0"
                      placeholder="Escribe tu mensaje aqui ..."
                    />
                    <span className="input-group-btn">
                      {props.formMessages.msg_desc.length > 0 ? (
                        <button
                          className="btn btn-primary info rounded-0"
                          onClick={() => handlerSendMessage()}
                        >
                          Enviar
                        </button>
                      ) : (
                        <button
                          className="btn btn-primary info rounded-0"
                          disabled
                        >
                          Enviar
                        </button>
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        )
      ) : (
        <React.Fragment>
          <Col className="text-center mb-1 p-0" xs={12}>
            <img className="icon-msg2" src={MESSAGE_ICON} alt="" />
          </Col>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

const MESSAGE_CHAT_CONTAINER_TEACHER = ({
  per_id,
  props,
  handlerSendMessage,
  onChangeMessage,
  setPerson,
  setPersonForum,
  isOpenMessage,
  isGradeSelected,
  handlerGoback,
  handlerGobackToGrade,
  reload,
}: any) => (
  <React.Fragment>
    <Row>
      <Col className="containerDocList d-block d-sm-none" xs={12} sm={4}>
        {/* MOBILE */}
        {isGradeSelected && !isOpenMessage ? (
          <MESSAGE_PERSON_LIST
            props={props}
            setPerson={setPerson}
            setPersonForum={setPersonForum}
            handlerGoback={handlerGobackToGrade}
            isBack={true}
          />
        ) : (
          <MESSAGE_CHAT_INTERFACE
            per_person={per_id}
            props={props}
            handlerSendMessage={handlerSendMessage}
            onChangeMessage={onChangeMessage}
            isOpenMessage={isOpenMessage}
            handlerGoback={handlerGoback}
            isOpenButtonback={true}
            reload={reload}
          />
        )}
      </Col>

      <Col className="containerDocList d-none d-sm-block desktop" xs={12}>
        {/* DESKTOP */}
        <Row>
          <Col xs={4}>
            <MESSAGE_PERSON_LIST
              props={props}
              setPerson={setPerson}
              setPersonForum={setPersonForum}
              handlerGoback={handlerGobackToGrade}
              isBack={true}
            />
          </Col>
          <Col xs={8}>
            <MESSAGE_CHAT_INTERFACE
              per_person={per_id}
              props={props}
              handlerSendMessage={handlerSendMessage}
              onChangeMessage={onChangeMessage}
              isOpenMessage={isOpenMessage}
              handlerGoback={handlerGoback}
              isOpenButtonback={true}
              reload={reload}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  </React.Fragment>
);

const MESSAGE_CHAT_CONTAINER = ({
  per_id,
  props,
  handlerSendMessage,
  onChangeMessage,
  setPerson,
  openForum,
  setPersonForum,
  isOpenMessage,
  handlerGoback,
  reload,
  isOpenForum,
}: any) => (
  <React.Fragment>
    <Col className="containerDocList d-block d-sm-none" xs={12} sm={4}>
      {" "}
      {/* MOBILE */}
      {!isOpenMessage ? (
        <React.Fragment>
          {isOpenForum ? (
            <MESSAGE_PERSON_LIST_FORUM
              props={props}
              setPerson={setPerson}
              setPersonForum={setPersonForum}
              isBack={false}
            />
          ) : (
            <MESSAGE_PERSON_LIST
              props={props}
              setPerson={setPerson}
              setPersonForum={openForum}
              isBack={false}
            />
          )}
        </React.Fragment>
      ) : (
        <MESSAGE_CHAT_INTERFACE
          per_person={per_id}
          props={props}
          handlerSendMessage={handlerSendMessage}
          onChangeMessage={onChangeMessage}
          isOpenMessage={isOpenMessage}
          handlerGoback={handlerGoback}
          isOpenButtonback={true}
          reload={reload}
        />
      )}
    </Col>
    <Col className="containerDocList d-none d-sm-block desktop" xs={12}>
      {/* DESKTOP */}
      <Row>
        <Col xs={4}>
          {isOpenForum ? (
            <MESSAGE_PERSON_LIST_FORUM
              props={props}
              setPerson={setPerson}
              setPersonForum={setPersonForum}
              isBack={false}
            />
          ) : (
            <MESSAGE_PERSON_LIST
              props={props}
              setPerson={setPerson}
              setPersonForum={openForum}
              isBack={false}
            />
          )}
        </Col>
        <Col xs={8}>
          <MESSAGE_CHAT_INTERFACE
            per_person={per_id}
            props={props}
            handlerSendMessage={handlerSendMessage}
            onChangeMessage={onChangeMessage}
            isOpenMessage={isOpenMessage}
            handlerGoback={handlerGoback}
            isOpenButtonback={false}
            reload={reload}
          />
        </Col>
      </Row>
    </Col>
  </React.Fragment>
);

const GET_DATE_MONTH_DAY = ({ startDate, endDate }: any) => {
  var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  var dateArray = [];
  var currentDate = moment(startDate);
  var stopDate = moment(endDate);
  var date;
  while (currentDate <= stopDate) {
    date = currentDate;
    if (date.isoWeekday() !== 6 && date.isoWeekday() !== 7) {
      dateArray.push({
        title: `${months[currentDate.month()]} ${moment(currentDate).format(
          "DD"
        )}`,
        date: moment(currentDate).format("YYYY-MM-DD"),
      });
    }
    currentDate = moment(currentDate).add(1, "days");
  }
  return dateArray;
};

const GET_WEEK_START_END = ({ startDate, endDate }: any) => {
  var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  var dateArray = [];
  var currentDate = moment(startDate);
  var stopDate = moment(endDate);
  var date;
  while (currentDate <= stopDate) {
    date = currentDate;
    if (
      date.isoWeekday() !== 2 &&
      date.isoWeekday() !== 3 &&
      date.isoWeekday() !== 4 &&
      date.isoWeekday() !== 5 &&
      date.isoWeekday() !== 6 &&
      date.isoWeekday() !== 7
    ) {
      dateArray.push({
        title: `${moment(currentDate).format("DD")} de ${
          months[currentDate.month()]
        } al ${moment(currentDate).add(4, "days").format("DD")} de ${
          months[Number(moment(currentDate).add(4, "days").format("MM")) - 1]
        }`,

        dateStart: moment(currentDate).format("YYYY-MM-DD"),
        dateEnd: moment(currentDate).add(6, "days").format("YYYY-MM-DD"),
      });
    }
    currentDate = moment(currentDate).add(1, "days");
  }
  return dateArray;
};

const FIND_DESC = (arr, elm) => {
  // eslint-disable-next-line array-callback-return
  const result = arr.find(function (item) {
    if (item.per_cedula !== undefined) {
      if (
        item.per_cedula.toLowerCase() === elm.toLowerCase().replace(/\s+/g, "")
      )
        return true;
    }
    if (item.cxcd_type !== undefined) {
      if (
        item.cxcd_type.toLowerCase() === elm.toLowerCase().replace(/\s+/g, "")
      )
        return true;
    }
  });
  if (result !== undefined) return true;
  else return false;
};

const TRIMESTRE_HANDLER = (trimestre, operation) => {
  var current;
  if (trimestre === "I") {
    if (operation === "right") {
      current = "II";
    } else {
      current = "I";
    }
  } else if (trimestre === "II") {
    if (operation === "right") {
      current = "III";
    } else {
      current = "I";
    }
  } else if (trimestre === "III") {
    if (operation === "left") {
      current = "II";
    } else {
      current = "III";
    }
  }
  return current;
};

const PAYMENT_ACCOUNT_STUDENT = ({ props, fetchType, dataCxc }: any) => {
  return (
    <React.Fragment>
      <Row className="table-alert-color-no-height">
        <Col xs={4} sm={2} className="text-left lh-40">
          <Label className="font-weight-bold">Matricula: B/. </Label>
        </Col>
        <Col xs={8} sm={2} className="text-left">
          <FormGroup>
            <Input
              type="text"
              name="cxcr_matricula"
              rows="5"
              defaultValue={props.formMatricula.cxcr_matricula}
              id="cxcr_matricula"
              placeholder="B/."
              disabled
            />
          </FormGroup>
        </Col>
        <Col xs={4} sm={1} className="text-left lh-40">
          <Label className="font-weight-bold">Saldo</Label>
        </Col>
        <Col xs={8} sm={2} className="text-left">
          <FormGroup>
            <Input
              type="text"
              name="cxcr_matricula"
              rows="5"
              defaultValue={props.formMatricula.cxcr_matricula}
              id="cxcr_matricula"
              placeholder="B/."
              disabled
            />
          </FormGroup>
        </Col>
        <Col xs={8} sm={1} className="text-center">
          <ButtonGroup>
            {props.formMatricula.cxcr_stado === "2" && (
              <Button className="ok" active={true}>
                Pago
              </Button>
            )}
            {props.formMatricula.cxcr_stado === "1" && (
              <Button className="danger-btn" active={true}>
                Debe
              </Button>
            )}
            {props.formMatricula.cxcr_stado === "3" && (
              <Button className="info" active={true}>
                Saldo
              </Button>
            )}
          </ButtonGroup>
        </Col>
        <Col xs={4} sm={2} className="text-left lh-40">
          <Label className="font-weight-bold">Fecha de pago: </Label>
        </Col>
        <Col xs={8} sm={2} className="text-left">
          <FormGroup>
            <Input
              type="text"
              name="cxcr_date"
              defaultValue={props.formMatricula.cxcr_date}
              id="cxcr_date"
              placeholder="YYYY-MM-DD"
              disabled
            />
          </FormGroup>
        </Col>
        <Col sm={3}></Col>
        <Col xs={3} className="text-right lh-40"></Col>
        <Col xs={12} className="bts-1px mt-2 mb-2"></Col>
        <Col xs={12} className="table-libreta">
          <DatatableExpand
            data={props.dataCxcType}
            columns={COLUMNS_CXC_CUOTA_ECUENTA()}
            keyProp="cxc_id"
            expandRow={COLUMNS_CXC_ECUENTAS(fetchType, dataCxc)}
            exportD={false}
            searchs={false}
          />
        </Col>
        <Col xs={5}>
          <FormGroup>
            <Label className="font-weight-bold">Anualidad</Label>
            <Input
              type="text"
              defaultValue={props.formMatricula.cxcr_anualidad}
              name="cxcr_anualidad"
              id="cxcr_anualidad"
              placeholder=""
              disabled
            />
          </FormGroup>
        </Col>
        <Col xs={2}>
          <ButtonGroup className="prelative-btngorup">
            <Button
              className="ok"
              outline
              active={props.formMatricula.cxcr_anualidad_state === "2"}
            >
              Pago
            </Button>
            <Button
              className="danger-btn"
              outline
              active={props.formMatricula.cxcr_anualidad_state === "1"}
            >
              Debe
            </Button>
          </ButtonGroup>
        </Col>
        <Col xs={5}>
          <Label className="font-weight-bold">Saldo de colegiatura</Label>
          <FormGroup>
            <Input
              type="text"
              defaultValue={props.formMatricula.cxcr_saldo_cole}
              name="cxcr_saldo_cole"
              id="cxcr_saldo_cole"
              placeholder=""
              disabled
            />
          </FormGroup>
        </Col>

        {props.ap_desc.length > 0 ? (
          <React.Fragment>
            <Col xs={12} className="text-left">
              <Label className="font-weight-bold">Arreglo de pago</Label>
            </Col>
            <Col xs={12}>
              <FormGroup>
                <Input
                  type="textarea"
                  name="ap_desc"
                  rows="6"
                  defaultValue={props.ap_desc}
                  id="ap_desc"
                  disabled
                />
              </FormGroup>
            </Col>
          </React.Fragment>
        ) : null}
      </Row>
    </React.Fragment>
  );
};

const PAYMENT_ACCOUNT = ({ props, goBack, fetchType, dataCxc }: any) => {
  return (
    <React.Fragment>
      <Row>
        <Col sm={12} className="text-right">
          <Button color="success" className="mr-2" onClick={() => goBack()}>
            Cerrar
          </Button>
        </Col>
        <Col xs={3} sm={2} className="text-left lh-40">
          <Label className="font-weight-bold">Matricula: B/. </Label>
        </Col>
        <Col xs={3} sm={3} className="text-left">
          <FormGroup>
            <Input
              type="text"
              name="cxcr_matricula"
              rows="5"
              value={props.formMatricula.cxcr_matricula}
              id="cxcr_matricula"
              placeholder="B/."
              disabled
            />
          </FormGroup>
        </Col>
        <Col xs={7} sm={7}></Col>
        <Col xs={3} sm={2} className="text-left lh-40">
          <Label className="font-weight-bold">Saldo: B/. </Label>
        </Col>
        <Col xs={3} sm={2} className="text-left">
          <FormGroup>
            <Input
              type="text"
              name="cxcr_saldo"
              rows="5"
              value={props.formMatricula.cxcr_saldo}
              id="cxcr_saldo"
              placeholder="B/."
              disabled
            />
          </FormGroup>
        </Col>
        <Col xs={8} sm={8} className="text-left">
          <ButtonGroup>
            {props.formMatricula.cxcr_stado === "2" && (
              <Button color="success" active={true}>
                Pago
              </Button>
            )}
            {props.formMatricula.cxcr_stado === "1" && (
              <Button color="danger" active={true}>
                Debe
              </Button>
            )}
            {props.formMatricula.cxcr_stado === "3" && (
              <Button color="danger" active={true}>
                Saldo
              </Button>
            )}
          </ButtonGroup>
        </Col>
        <Col xs={4} sm={3} className="text-left lh-40">
          <Label className="font-weight-bold">Proxima fecha de pago: </Label>
        </Col>
        <Col xs={8} sm={3} className="text-left">
          <FormGroup>
            <Input
              type="text"
              name="cxcr_date"
              defaultValue={props.formMatricula.cxcr_date}
              id="cxcr_date"
              placeholder="YYYY-MM-DD"
              disabled
            />
          </FormGroup>
        </Col>
        <Col sm={3}></Col>
        <Col xs={3} className="text-right lh-40"></Col>
        <Col xs={12} className="bts-1px mt-2 mb-2"></Col>
        <Col xs={12}>
          <DatatableExpand
            data={props.dataCxcType}
            columns={COLUMNS_CXC_CUOTA_ECUENTA()}
            keyProp="cxc_id"
            expandRow={COLUMNS_CXC_ECUENTAS(fetchType, dataCxc)}
            exportD={false}
            searchs={false}
          />
        </Col>
        <Col xs={5}>
          <FormGroup>
            <Label className="font-weight-bold">Anualidad</Label>
            <Input
              type="text"
              defaultValue={props.formMatricula.cxcr_anualidad}
              name="cxcr_anualidad"
              id="cxcr_anualidad"
              placeholder=""
              disabled
            />
          </FormGroup>
        </Col>
        <Col xs={2}>
          <ButtonGroup className="prelative-btngorup">
            <Button
              color="success"
              outline
              active={props.formMatricula.cxcr_anualidad_state === "2"}
            >
              Pago
            </Button>
            <Button
              color="success"
              outline
              active={props.formMatricula.cxcr_anualidad_state === "1"}
            >
              Debe
            </Button>
          </ButtonGroup>
        </Col>
        <Col xs={5}>
          <Label className="font-weight-bold">Saldo de colegiatura</Label>
          <FormGroup>
            <Input
              type="text"
              defaultValue={props.formMatricula.cxcr_saldo_cole}
              name="cxcr_saldo_cole"
              id="cxcr_saldo_cole"
              placeholder=""
              disabled
            />
          </FormGroup>
        </Col>
        <Col xs={12} className="text-left">
          <Label className="font-weight-bold">Arreglo de pago</Label>
        </Col>
        {props.ap_desc.length > 0 ? (
          <Col xs={12}>
            <FormGroup>
              <Input
                type="textarea"
                name="ap_desc"
                rows="4"
                defaultValue={props.ap_desc}
                id="ap_desc"
                disabled
              />
            </FormGroup>
          </Col>
        ) : null}
      </Row>
    </React.Fragment>
  );
};

const validateTokenStorage = () => {
  var x = reactLocalStorage.getObject("tokenP");
  const hashDigest = sha256(
    nonce + x.usr_type + x.per_id + x.per_admin + x.per_std
  );
  const hmacDigest = Base64.stringify(
    hmacSHA512(path + hashDigest, privateKey)
  );
  if (x.key !== undefined) {
    if (x.key !== hmacDigest) {
      return true;
    }
  }
  return false;
};

const getNameHabitop = (props, key) => {
  if (key === "bh_respect") return props.bh_respect;
  if (key === "bh_order_neather") return props.bh_order_neather;
  if (key === "bh_respons") return props.bh_respons;
  if (key === "bh_civism") return props.bh_civism;
  if (key === "bh_honesty") return props.bh_honesty;
  if (key === "bh_coopera") return props.bh_coopera;
  if (key === "bh_manners") return props.bh_manners;
  if (key === "bh_puntual") return props.bh_puntual;
  if (key === "bh_selfcont") return props.bh_selfcont;
  return null;
};

const getHabitosAptitudes = (props, trimestre) => {
  var result;
  for (var key in props) {
    result = Object.keys(props[key]).map((property, i) => {
      if (
        property !== "bh_observacion" &&
        property !== "bh_boletin" &&
        property !== "bh_id" &&
        property !== "bh_trimestre"
      ) {
        return (
          <React.Fragment key={i}>
            <Col xs={6} className=" text-left habitos-height">
              <Label className="font-weight-bold">
                {dataHAptitudes[property]}
              </Label>
            </Col>

            <Col
              xs={2}
              className="border-boletin text-center border-top-u border-bottom-u habitos-height"
            >
              <Label className="font-weight-bold">
                {props[0] === undefined
                  ? null
                  : getNameHabitop(props[0], property)}
              </Label>
            </Col>
            <Col
              xs={2}
              className="border-boletin text-center border-top-u border-bottom-u habitos-height"
            >
              <Label className="font-weight-bold">
                {props[1] === undefined
                  ? null
                  : getNameHabitop(props[1], property)}
              </Label>
            </Col>
            <Col
              xs={2}
              className="border-boletin text-center border-top-u border-bottom-u habitos-height"
            >
              <Label className="font-weight-bold">
                {props[2] === undefined
                  ? null
                  : getNameHabitop(props[2], property)}
              </Label>
            </Col>
          </React.Fragment>
        );
      }
      return null;
    });
  }
  return result;
};

const AREA_LIST = ({ dataArea, dataAsignature, numberArea }: any) => {
  return (
    <React.Fragment>
      <Col xs={12}>
        <Row>
          {dataArea.map((area, i) => {
            return (
              <Col xs={6} key={i}>
                <Row>
                  <Col xs={12} className="column-dark text-center">
                    <Label className="area-preescolar-title">
                      {area.ar_desc.toUpperCase()}
                    </Label>
                  </Col>
                  <Col xs={12}>
                    {dataAsignature.map((asig, ii) => {
                      if (area.ar_id === asig.ar_id) {
                        numberArea = numberArea + 1;
                        return (
                          <React.Fragment key={ii}>
                            <Label className="label-area-desc font-weight-bold">
                              {numberArea} &nbsp;
                            </Label>
                            <Label className="label-area-desc">
                              {asig.as_desc}
                            </Label>
                            <br></br>
                          </React.Fragment>
                        );
                      }
                      return null;
                    })}
                  </Col>
                </Row>
              </Col>
            );
          })}
        </Row>
      </Col>
    </React.Fragment>
  );
};
const NOTE_EDIT_TAREA_LITERAL = ({
  dataResult,
  dataAsistant,
  formCurrentAgenda,
  handlerGobackDetail,
  onChangeNota,
  handlerPutNote,
  handlerPostNote,
  handlerCancelNota,
  openModalAddComent,
  getFilesNames,
  handleKeyPress,
  loading,
}: any) => {
  return (
    <React.Fragment>
      <Col xs={12} className="text-right mb-4">
        <ClipLoader
          css={override}
          size={23}
          color={"#36D7B7"}
          loading={loading}
        />
        <Button className="ok" onClick={() => handlerGobackDetail()}>
          Cerrar
        </Button>
      </Col>
      <Col xs={12} className="text-center table-asist table-alert-color mt-4">
        <div className="search-table-outte">
          <table className="table  table-bordered table-libreta">
            <thead>
              <tr>
                <th className="">
                  <Label className="pointer-auto">Estudiante</Label>
                </th>
                <th className="">
                  <Label className="pointer-auto">Archivos</Label>
                </th>
                <th className="w-30porcent">
                  <Label className="pointer-auto">Comentario</Label>
                </th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(dataAsistant).map((key: any, i) => {
                return (
                  <tr key={i}>
                    <th className="label-area-desc-bold lib-height-edit text-left pl-3">
                      <Label className="prelative-libreta-edit">
                        {dataAsistant[key].length > 0
                          ? dataAsistant[key][0].per_name
                          : ""}
                      </Label>
                    </th>
                    {dataResult.map((data, r) => {
                      var exist = dataAsistant[key].find(
                        (e) =>
                          e.di_date === data.di_date && e.di_id === data.di_id
                      );

                      if (
                        exist !== undefined &&
                        data.di_date === formCurrentAgenda.di_date &&
                        data.di_id === formCurrentAgenda.di_id
                      ) {
                        return (
                          <React.Fragment key={r}>
                            <th className="label-area-desc-bold lib-height-edit text-center">
                              {exist.not_file_name.length > 0 ? (
                                <React.Fragment>
                                  <a
                                    className="label-download-file-libreta"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() =>
                                      getFilesNames({
                                        di_id: exist.di_id,
                                        per_id: exist.per_id,
                                      })
                                    }
                                    // href="#"
                                  >
                                    Ver Multimedia
                                    {/* <ImageViewerAgenda ad_img={filesObj}/> */}
                                  </a>
                                </React.Fragment>
                              ) : null}
                            </th>
                            <th className="label-area-desc-bold lib-height-edit text-center">
                              <Row>
                                <Col xs={9}>
                                  <FormGroup className="mb-0">
                                    <Input
                                      type="textarea"
                                      name="not_comment"
                                      rows="5"
                                      // onChange={onChange}
                                      defaultValue={exist.not_comment}
                                      id="not_comment"
                                      className="w-20porcent"
                                      // placeholder="Coloque aqui el comentario"
                                      disabled
                                    />
                                  </FormGroup>
                                </Col>
                                <Col xs={3}>
                                  {exist.not_comment.length > 0 ? (
                                    <img
                                      className="img-width-add"
                                      src={PENCIL}
                                      alt=""
                                      onClick={() =>
                                        openModalAddComent({
                                          di_id: exist.di_id,
                                          per_id: exist.per_id,
                                          per_name: exist.per_name,
                                          type: "put",
                                          not_comment: exist.not_comment,
                                        })
                                      }
                                    />
                                  ) : (
                                    <img
                                      className="img-width-add"
                                      src={MORE_ICON}
                                      alt=""
                                      onClick={() =>
                                        openModalAddComent({
                                          di_id: exist.di_id,
                                          per_id: exist.per_id,
                                          per_name: exist.per_name,
                                          type: "post",
                                          not_comment: exist.not_comment,
                                        })
                                      }
                                    />
                                  )}
                                </Col>
                              </Row>
                            </th>
                          </React.Fragment>
                        );
                      } else if (
                        data.di_date === formCurrentAgenda.di_date &&
                        data.di_id === formCurrentAgenda.di_id
                      ) {
                        return null;
                      }
                      return null;
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </Col>
      <Col xs={12} className="mt-3">
        <Alert color="success">
          <Row>
            <Col xs={6} sm={10} className="text-left mb-0">
              <h5 className="font-weight-bold">
                {moment(formCurrentAgenda.di_date).format("MM/DD/YYYY")}
              </h5>
            </Col>
            <Col xs={6} sm={2} className="text-center mb-0">
              <Label className="mb-0 ">{formCurrentAgenda.ta_desc}</Label>
            </Col>
            <Col xs={12} sm={12} className="text-justify mt-0">
              <hr />
              <p className="mb-0"> {formCurrentAgenda.di_desc}</p>
            </Col>
          </Row>
        </Alert>
      </Col>
    </React.Fragment>
  );
};

const NOTE_EDIT = ({
  dataResult,
  dataAsistant,
  formCurrentAgenda,
  handlerGobackDetail,
  onChangeNota,
  handlerPutNote,
  handlerPostNote,
  handlerCancelNota,
  openModalAddComent,
  getFilesNames,
  handleKeyPress,
  handleKeyPress_post,
  loading,
}: any) => {
  const MAX_VAL = 50;
  const withValueCap = (inputObj) => {
    const { value } = inputObj;
    if (value <= MAX_VAL) return inputObj;
  };
  return (
    <React.Fragment>
      <Col xs={12} className="text-right mb-4">
        <ClipLoader
          css={override}
          size={23}
          color={"#36D7B7"}
          loading={loading}
        />
        <Button className="ok" onClick={() => handlerGobackDetail()}>
          Cerrar
        </Button>
      </Col>
      <Col xs={12} className="text-center table-asist table-alert-color mt-4">
        <div className="search-table-outte">
          <table className="table  table-bordered table-libreta">
            <thead>
              <tr>
                <th className="">
                  <Label className="pointer-auto">Estudiante</Label>
                </th>
                <th className="">
                  <Label className="pointer-auto">Archivos</Label>
                </th>
                <th className="w-30porcent">
                  <Label className="pointer-auto">Comentario</Label>
                </th>
                <th className="hw-140">
                  <Label>{formCurrentAgenda.di_date}</Label>
                </th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(dataAsistant).map((key: any, i) => {
                return (
                  <tr key={i}>
                    <th className="label-area-desc-bold lib-height-edit text-left pl-3">
                      <Label className="prelative-libreta-edit">
                        {dataAsistant[key].length > 0
                          ? dataAsistant[key][0].per_name
                          : ""}
                      </Label>
                    </th>
                    {dataResult.map((data, r) => {
                      var exist = dataAsistant[key].find(
                        (e) =>
                          e.di_date === data.di_date && e.di_id === data.di_id
                      );

                      if (
                        exist !== undefined &&
                        data.di_date === formCurrentAgenda.di_date &&
                        data.di_id === formCurrentAgenda.di_id
                      ) {
                        return (
                          <React.Fragment key={r}>
                            <th className="label-area-desc-bold lib-height-edit text-center">
                              {exist.not_file_name.length > 0 ? (
                                <React.Fragment>
                                  <a
                                    className="label-download-file-libreta"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() =>
                                      getFilesNames({
                                        di_id: exist.di_id,
                                        per_id: exist.per_id,
                                      })
                                    }
                                    // href="#"
                                  >
                                    Ver Multimedia
                                    {/* <ImageViewerAgenda ad_img={filesObj}/> */}
                                  </a>
                                </React.Fragment>
                              ) : null}
                            </th>
                            <th className="label-area-desc-bold lib-height-edit text-center">
                              <Row>
                                <Col xs={9}>
                                  <FormGroup className="mb-0">
                                    <Input
                                      type="textarea"
                                      name="not_comment"
                                      rows="5"
                                      // onChange={onChange}
                                      defaultValue={exist.not_comment}
                                      id="not_comment"
                                      className="w-20porcent"
                                      // placeholder="Coloque aqui el comentario"
                                      disabled
                                    />
                                  </FormGroup>
                                </Col>
                                <Col xs={3}>
                                  {exist.not_comment.length > 0 ? (
                                    <img
                                      className="img-width-add"
                                      src={PENCIL}
                                      alt=""
                                      onClick={() =>
                                        openModalAddComent({
                                          di_id: exist.di_id,
                                          per_id: exist.per_id,
                                          per_name: exist.per_name,
                                          type: "put",
                                          not_comment: exist.not_comment,
                                        })
                                      }
                                    />
                                  ) : (
                                    <img
                                      className="img-width-add"
                                      src={MORE_ICON}
                                      alt=""
                                      onClick={() =>
                                        openModalAddComent({
                                          di_id: exist.di_id,
                                          per_id: exist.per_id,
                                          per_name: exist.per_name,
                                          type: "post",
                                          not_comment: exist.not_comment,
                                        })
                                      }
                                    />
                                  )}
                                </Col>
                              </Row>
                            </th>
                            <th key={r} className="d-flex lib-height-edit">
                              <React.Fragment key={r}>
                                <NumberFormat
                                  format="#.#"
                                  name="not_score"
                                  per_id={exist.per_id}
                                  className="input-change-score"
                                  onChange={onChangeNota}
                                  allowEmptyFormatting={true}
                                  // mask="0"
                                  defaultValue={Number(exist.not_score).toFixed(
                                    1
                                  )}
                                  // onKeyPress={handleKeyPress}
                                  onKeyPress={(e) =>
                                    handleKeyPress(e, exist.not_id)
                                  }
                                  placeholder="Nota"
                                  min="0"
                                  max="5"
                                  step="1"
                                  isAllowed={withValueCap}
                                />
                              </React.Fragment>
                            </th>
                          </React.Fragment>
                        );
                      } else if (
                        data.di_date === formCurrentAgenda.di_date &&
                        data.di_id === formCurrentAgenda.di_id
                      ) {
                        var exist2 = dataAsistant[key].find(
                          (e) =>
                            e.di_id === data.di_id
                        );
                        return (
                          <React.Fragment>
                            <th>

                            </th>
                            <th>

                            </th>
                          <th key={r} className="d-flex lib-height-edit">
                            <NumberFormat
                              format="#.#"
                              name="not_score"
                              className="input-change-score"
                              onChange={onChangeNota}
                              allowEmptyFormatting={true}
                              // defaultValue={Number(exist.not_score).toFixed(
                              //   1
                              // )}
                              placeholder="Nota"
                              onKeyPress={(e) =>
                                handleKeyPress_post(e, dataAsistant[key][0].per_id,data.di_id)
                              }
                              min="0"
                              max="5"
                              step="1"
                              isAllowed={withValueCap}
                            />
                          </th>
                          </React.Fragment>

                        );
                      }
                      return null;
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </Col>
      <Col xs={12} className="mt-3">
        <Alert color="success">
          <Row>
            <Col xs={6} sm={10} className="text-left mb-0">
              <h5 className="font-weight-bold">
                {moment(formCurrentAgenda.di_date).format("MM/DD/YYYY")}
              </h5>
            </Col>
            <Col xs={6} sm={2} className="text-center mb-0">
              <Label className="mb-0 ">{formCurrentAgenda.ta_desc}</Label>
            </Col>
            <Col xs={12} sm={12} className="text-justify mt-0">
              <hr />
              <p className="mb-0"> {formCurrentAgenda.di_desc}</p>
            </Col>
          </Row>
        </Alert>
      </Col>
    </React.Fragment>
  );
};

const NOTA_PROMEDIO_DIVIDO = ({
  dataResult,
  dataAsistant,
  di_idET,
  di_dateET,
  di_descET,
  ta_descET,
  handlerNota,
}: any) => {
  return (
    <React.Fragment>
      <table className="table  table-bordered table-libreta">
        <thead>
          <tr>
            <th className="w-name-libreta mobile-none static-col">
              <Label className="pointer-auto">Estudiante</Label>
            </th>
            <th className="hw-150 mobile-w">
              <Label className="pointer-auto">Prom.</Label>{" "}
            </th>
            <th className="hw-150 info mobile-w">
              <Label className="pointer-auto">Aprec.</Label>
            </th>
            <th className="hw-150 ok mobile-w">
              <Label className="pointer-auto">Diarias</Label>
            </th>
            {dataResult.map((data, i) => {
              if (data.ta_id !== "6") {
                return (
                  <th key={i} className="hw-150 mobile-w">
                    <Label
                      className={
                        data.ta_id === "3"
                          ? "pointer-auto border-b-apre"
                          : "border-b-diary pointer-auto"
                      }
                      onClick={() =>
                        handlerNota(
                          data.di_id,
                          data.di_date,
                          data.di_desc,
                          data.ta_desc
                        )
                      }
                    >
                      {data.di_date} ({data.di_id})
                    </Label>
                  </th>
                );
              }
              return null;
            })}
            <th className="hw-150 warning mobile-w">
              <Label
                className="pointer-auto"
                onClick={() =>
                  handlerNota(di_idET, di_dateET, di_descET, ta_descET)
                }
              >
                E. Trimestral
              </Label>
            </th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(dataAsistant).map((key: any, i) => {
            var prom = 0;
            var aprec = 0;
            var notaET = 0;
            var notaD = 0;
            var promCount = 0;
            var aprecCount = 0;
            var notaDCount = 0;
            var promF = 0;
            dataAsistant[key].map((sum, i) => {
              if (sum.ta_id === "3") {
                aprec = Number(aprec) + Number(sum.not_score);
                aprecCount = Number(aprecCount) + 1;
              } else if (sum.ta_id === "6") {
                notaET = Number(sum.not_score);
              } else {
                notaD = Number(notaD) + Number(sum.not_score);
                notaDCount = Number(notaDCount) + 1;
              }
              promCount = Number(promCount) + 1;

              prom = Number(prom) + Number(sum.not_score);

              return null;
            });
            promF = aprec / aprecCount + notaD / notaDCount + notaET;
            return (
              <tr key={i}>
                <th className="label-area-desc-bold lib-height text-left static-col">
                  <Label className="pl-2">
                    {dataAsistant[key].length > 0
                      ? dataAsistant[key][0].per_name
                      : ""}
                  </Label>
                </th>
                <th className="label-area-desc-bold lib-height text-center">
                  <Label>{TruncarNotas(Number(promF / 3), 1)}</Label>
                </th>
                <th className="label-area-desc-bold lib-height text-center">
                  <Label>
                    {aprecCount > 0
                      ? TruncarNotas(Number(aprec / aprecCount), 1)
                      : null}
                  </Label>
                </th>
                <th className="label-area-desc-bold lib-height text-center">
                  <Label>
                    {notaDCount > 0
                      ? TruncarNotas(Number(notaD / notaDCount), 1)
                      : null}
                  </Label>
                </th>
                {dataResult.map((data, r) => {
                  if (data.ta_id !== "6") {
                    var exist = dataAsistant[key].find(
                      (e) =>
                        e.di_date === data.di_date && e.di_id === data.di_id
                    );
                    if (exist !== undefined) {
                      return (
                        <th key={r} className="lib-height">
                          <Label className="pbottom-u label-area-desc-bold">
                            {Number(exist.not_score).toFixed(1)}
                          </Label>
                        </th>
                      );
                    } else {
                      return <th key={r}></th>;
                    }
                  }
                  return null;
                })}
                <th className="label-area-desc-bold lib-height text-center">
                  <Label>{Number(notaET).toFixed(1)}</Label>
                </th>
              </tr>
            );
          })}
        </tbody>
      </table>
    </React.Fragment>
  );
};

const NOTA_VER_TAREA_LITERAL = ({
  getFilesNames,
  dataResult,
  dataAsistant,
  di_idET,
  di_dateET,
  di_descET,
  ta_descET,
  handlerNota,
}: any) => {
  return (
    <React.Fragment>
      <table className="table  table-bordered table-libreta">
        <thead>
          <tr>
            <th className="w-name-libreta mobile-none">
              <Label className="pointer-auto">Estudiante</Label>
            </th>
            {dataResult.map((data, i) => {
              return (
                <th key={i} className="hw-150 mobile-w">
                  <Label
                    className="pointer-auto"
                    // onClick={() =>
                    //   handlerNota(
                    //     data.di_id,
                    //     data.di_date,
                    //     data.di_desc,
                    //     data.ta_desc
                    //   )
                    // }
                  >
                    {data.di_date} ({data.di_id})
                  </Label>
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {Object.keys(dataAsistant).map((key: any, i) => {
            return (
              <tr key={i}>
                <th className="label-area-desc-bold lib-height text-left">
                  <Label className="pl-2">
                    {dataAsistant[key].length > 0
                      ? dataAsistant[key][0].per_name
                      : ""}
                  </Label>
                </th>
                {dataResult.map((data, r) => {
                  var exist = dataAsistant[key].find(
                    (e) => e.di_date === data.di_date && e.di_id === data.di_id
                  );
                  if (exist !== undefined) {
                    return (
                      <th key={r} className="lib-height">
                        {exist.not_file_name.length > 0 ? (
                          <React.Fragment>
                            <a
                              className="label-download-file-libreta img-observation-handler-literal-2"
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={() =>
                                getFilesNames({
                                  di_id: exist.di_id,
                                  per_id: exist.per_id,
                                })
                              }
                              // href="#"
                            >
                              Ver Multimedia
                              {/* <ImageViewerAgenda ad_img={filesObj}/> */}
                            </a>
                          </React.Fragment>
                        ) : null}
                      </th>
                    );
                  } else {
                    return <th key={r}></th>;
                  }
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </React.Fragment>
  );
};

const NOTA_PROMEDIO_NORMAL = ({
  dataResult,
  dataAsistant,
  di_idET,
  di_dateET,
  di_descET,
  ta_descET,
  handlerNota,
}: any) => {
  return (
    <React.Fragment>
      <table className="table  table-bordered table-libreta">
        <thead>
          <tr>
            <th className="w-name-libreta mobile-none static-col">
              <Label className="pointer-auto">Estudiante</Label>
            </th>
            <th className="hw-150 mobile-w ok">
              <Label className="pointer-auto">Prom.</Label>{" "}
            </th>
            {dataResult.map((data, i) => {
              return (
                <th key={i} className="hw-150 mobile-w">
                  <Label
                    className="pointer-auto"
                    onClick={() =>
                      handlerNota(
                        data.di_id,
                        data.di_date,
                        data.di_desc,
                        data.ta_desc
                      )
                    }
                  >
                    {data.di_date} ({data.di_id})
                  </Label>
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {Object.keys(dataAsistant).map((key: any, i) => {
            var prom = 0;
            var promCount = 0;
            dataAsistant[key].map((sum, i) => {
              promCount = Number(promCount) + 1;
              prom = Number(prom) + Number(sum.not_score);
              return null;
            });
            return (
              <tr key={i}>
                <th className="label-area-desc-bold lib-height text-left static-col">
                  <Label className="pl-2">
                    {dataAsistant[key].length > 0
                      ? dataAsistant[key][0].per_name
                      : ""}
                  </Label>
                </th>
                <th className="label-area-desc-bold lib-height text-center">
                  <Label>{TruncarNotas(Number(prom / promCount), 1)}</Label>
                </th>
                {dataResult.map((data, r) => {
                  var exist = dataAsistant[key].find(
                    (e) => e.di_date === data.di_date && e.di_id === data.di_id
                  );
                  if (exist !== undefined) {
                    return (
                      <th key={r} className="lib-height">
                        <Label className="pbottom-u label-area-desc-bold">
                          {Number(exist.not_score).toFixed(1)}
                        </Label>
                      </th>
                    );
                  } else {
                    return <th key={r}></th>;
                  }
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </React.Fragment>
  );
};

const NOTA_PROMEDIO_LITERAL = ({
  dataArea,
  dataAsistant,
  dataAsignatureArea,
  handlerSetCalification,
}: any) => {
  dataAsignatureArea.sort(function (a, b) {
    return a.ar_id - b.ar_id;
  });

  return (
    <React.Fragment>
      <table className="table  table-bordered">
        <thead>
          <tr className="sblue border-bottom-u border-top-unset">
            <th className="border-bottom-u static-col-blues-2">
              <Label className="pointer-auto w-250px">Areas</Label>
            </th>

            {dataArea.map((area, i) => {
              return (
                <th key={i} className="hw-150">
                  <Label className="pointer-auto">
                    {area.ar_desc.toUpperCase()}
                  </Label>
                </th>
              );
            })}
          </tr>
          <tr>
            <th className="border-top-u sblue border-bottom-u border-top-unset static-col-blue">
              <Label className="pointer-auto"># Asignatura</Label>
            </th>
            {dataArea.map((area, i) => {
              return (
                <th key={i}>
                  <div className="d-flex">
                    {dataAsignatureArea.map((asig, ii) => {
                      if (area.ar_id === asig.ar_id) {
                        return (
                          <div key={ii} className="w-asig">
                            <Label key={ii}>{Number(ii) + 1}</Label>
                          </div>
                        );
                      }
                      return null;
                    })}
                  </div>
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {Object.keys(dataAsistant).map((key: any, index) => {
            return (
              <tr key={index}>
                <th className="text-left border-student-preescolar static-col-blue">
                  <Label className="name-student-prescolar">
                    {dataAsistant[key].length > 0
                      ? dataAsistant[key][0].per_name
                      : ""}
                  </Label>
                </th>
                {dataArea.map((area, i) => {
                  var dataByArea = [];
                  dataAsistant[key].map((dataA, iii) => {
                    if (dataA.ar_id === area.ar_id) {
                      dataByArea.push(dataA);
                    }
                    return null;
                  });
                  return (
                    <React.Fragment key={i}>
                      <th>
                        <div className="d-flex">
                          {dataAsignatureArea.map((asig, ii) => {
                            if (area.ar_id === asig.ar_id) {
                              var exist = dataByArea.find(
                                (e) => e.not_topico === asig.as_id
                              );

                              if (exist !== undefined) {
                                if (exist.not_topico === asig.as_id) {
                                  return (
                                    <div className="w-asig" key={ii}>
                                      <select
                                        name="calification_drop"
                                        className="ok"
                                        defaultValue={exist.not_literal}
                                        onChange={(e) => {
                                          handlerSetCalification({
                                            not_literal: e.target.value,
                                            not_id: exist.not_id,
                                            type: "put",
                                            not_topico: asig.as_id,
                                            not_person: null,
                                          });
                                        }}
                                      >
                                        <option value="">--</option>
                                        <option value="LHL">LHL</option>
                                        <option value="LEL">LEL</option>
                                        <option value="LVL">LVL</option>
                                      </select>
                                    </div>
                                  );
                                } else {
                                  return (
                                    <div className="w-asig" key={ii}>
                                      <select
                                        name="calification_drop"
                                        className="info"
                                        onChange={(e) => {
                                          handlerSetCalification({
                                            not_literal: e.target.value,
                                            not_id: null,
                                            type: "post",
                                            not_topico: asig.as_id,
                                            not_person:
                                              dataAsistant[key][0].per_id,
                                          });
                                        }}
                                      >
                                        <option value="">--</option>
                                        <option value="LHL">LHL</option>
                                        <option value="LEL">LEL</option>
                                        <option value="LVL">LVL</option>
                                      </select>
                                    </div>
                                  );
                                }
                              }
                              return (
                                <div className="w-asig" key={ii}>
                                  <select
                                    name="calification_drop"
                                    className="info"
                                    onChange={(e) => {
                                      handlerSetCalification({
                                        not_literal: e.target.value,
                                        not_id: null,
                                        type: "post",
                                        not_topico: asig.as_id,
                                        not_person: dataAsistant[key][0].per_id,
                                      });
                                    }}
                                  >
                                    <option value="">--</option>
                                    <option value="LHL">LHL</option>
                                    <option value="LEL">LEL</option>
                                    <option value="LVL">LVL</option>
                                  </select>
                                </div>
                              );
                            }
                            return null;
                          })}
                        </div>
                      </th>
                    </React.Fragment>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </React.Fragment>
  );
};

const HOUR_BODY_PRINT = ({ typePerson, dataHour }) => {
  return (
    <React.Fragment>
      <Row className="mt-5" key={new Date().toString()}>
        <Col xs={12} className="text-center mb-5 mt-5">
          <img alt="" className="logo-school-informe" src={LOGO_SCHOOL}></img>
          <h4 className="font-weight-bold h4-prelative">
            The King's School David <br></br>
            <br></br>
            HORARIO DE CLASES
          </h4>
        </Col>
        <Col xs={12} className="text-center">
          <Table bordered className="m-auto table-libreta-print">
            <thead>
              <tr>
                <th>
                  <Label> HORA</Label>
                </th>
                <th>
                  <Label> LUNES</Label>
                </th>
                <th>
                  <Label> MARTES</Label>
                </th>
                <th>
                  <Label> MIERCOLES</Label>
                </th>
                <th>
                  <Label> JUEVES</Label>
                </th>
                <th>
                  <Label> VIERNES</Label>
                </th>
              </tr>
            </thead>
            <tbody>
              {typePerson === "teacher"
                ? dataHour.map((data, i) => (
                    <tr key={i}>
                      <th
                        className="w-body-hour "
                        style={{ background: "blue" }}
                      >
                        {" "}
                        <Label>{`${moment(data.tas_hourstar).format(
                          "hh:mm"
                        )} - ${moment(data.tas_hourend).format(
                          "hh:mm"
                        )}`}</Label>{" "}
                      </th>
                      <th>
                        {" "}
                        <Label>
                          {" "}
                          {data.grdesc_lunes !== null ||
                          data.asdesc_lunes !== null
                            ? `${data.grdesc_lunes} - ${data.asdesc_lunes} `
                            : null}
                        </Label>{" "}
                      </th>
                      <th>
                        <Label>
                          {" "}
                          {data.grdesc_martes !== null ||
                          data.asdesc_martes !== null
                            ? `${data.grdesc_martes} - ${data.asdesc_martes} `
                            : null}
                        </Label>
                      </th>
                      <th>
                        <Label>
                          {" "}
                          {data.grdesc_miercoles !== null ||
                          data.asdesc_miercoles !== null
                            ? `${data.grdesc_miercoles} - ${data.asdesc_miercoles} `
                            : null}
                        </Label>
                      </th>
                      <th>
                        <Label>
                          {" "}
                          {data.grdesc_jueves !== null ||
                          data.asdesc_jueves !== null
                            ? `${data.grdesc_jueves} - ${data.asdesc_jueves} `
                            : null}
                        </Label>
                      </th>
                      <th>
                        <Label>
                          {" "}
                          {data.grdesc_viernes !== null ||
                          data.asdesc_viernes !== null
                            ? `${data.grdesc_viernes} - ${data.asdesc_viernes} `
                            : null}
                        </Label>
                      </th>
                    </tr>
                  ))
                : dataHour.map((data, i) => (
                    <tr key={i}>
                      <th className="w-body-hour">{`${moment(
                        data.hr_hourstart
                      ).format("hh:mm")} - ${moment(data.hr_hourend).format(
                        "hh:mm"
                      )}`}</th>
                      <th>
                        <Label> {data.asdesc_lunes}</Label>
                      </th>
                      <th>
                        <Label> {data.asdesc_martes}</Label>
                      </th>
                      <th>
                        <Label> {data.asdesc_miercoles}</Label>
                      </th>
                      <th>
                        <Label> {data.asdesc_jueves}</Label>
                      </th>
                      <th>
                        <Label> {data.asdesc_viernes}</Label>
                      </th>
                    </tr>
                  ))}
            </tbody>
          </Table>
        </Col>
      </Row>
    </React.Fragment>
  );
};

const TruncarNotas = (number, decimales) => {
  if (decimales === 1) {
    if (number.toString().length === 1) {
      return number + ".0";
    } else {
      return number.toString().match(/^-?\d+(?:\.\d{0,1})?/);
    }
  }
  if (decimales === 2) {
    if (number.toString().length === 1) {
      return number + ".00";
    }
    if (number.toString().length === 3) {
      return number + "0";
    } else {
      return number.toString().match(/^-?\d+(?:\.\d{0,2})?/);
    }
  }
  return number;
};

const BODY_CUENTAS = ({ props, setDebePagar, setMorosidad, openAddPago }) => {
  return (
    <React.Fragment>
      <Col xs={12} className="mt-3 text-center info">
        <Label>
          {props.cxc_cobrar.length > 8 ? <b>MENSUALIDAD</b> : <b>ANUALIDAD</b>}
        </Label>
      </Col>

      <Table bordered>
        <thead>
          <tr>
            <th className="text-center">
              <b>Tipo de pago</b>
            </th>
            <th className="text-center">
              <b>Monto</b>
            </th>
            <th className="text-center">
              <b>Cancelado</b>
            </th>
            <th className="text-center">
              <b>Por pagar</b>
            </th>
            <th className="text-center">
              <b>Debe pagar</b>
            </th>
            <th className="text-center">
              <b>Morosidad 10%</b>
            </th>
            <th className="text-center">
              <b>Incluir pago</b>
            </th>
          </tr>
        </thead>
        <tbody>
          {props.cxc_cobrar.map((data, i) => {
            return (
              <tr key={i}>
                <td>
                  <Row className="text-left">
                    <Col xs={12}>
                      {props.formMatricula.cxcr_anualidad_state === "1" ? (
                        <b>Anualidad</b>
                      ) : (
                        <b>Cuota N{data.cxc_cuota}</b>
                      )}
                    </Col>
                    <Col xs={12}>Plataforma</Col>
                    <Col xs={12}>Edu. fisica</Col>
                    <Col xs={12}>Robótica</Col>
                  </Row>
                </td>
                <td>
                  {" "}
                  <Row className="text-center">
                    <Col xs={12}>
                      {props.formMatricula.cxcr_anualidad_state === "1" ? (
                        props.formMatricula.cxcr_anualidad
                      ) : data.cxc_morostado === "1" ? (
                        <b>
                          {(
                            Number(props.formMatricula.cxcr_mensualidad) * 1.1
                          ).toFixed(2)}
                        </b>
                      ) : (
                        props.formMatricula.cxcr_mensualidad
                      )}
                    </Col>
                    <Col xs={12}>
                      {props.formMatricula.cxcr_anualidad_state === "1"
                        ? props.formMonto.mt_a_plataforma
                        : props.formMonto.mt_plataforma}
                    </Col>
                    <Col xs={12}>
                      {props.formMatricula.cxcr_anualidad_state === "1"
                        ? props.formMonto.mt_a_efisica
                        : props.formMonto.mt_efisica}
                    </Col>
                    <Col xs={12}>
                      {props.formMatricula.cxcr_anualidad_state === "1"
                        ? props.formMonto.mt_a_robotica
                        : props.formMonto.mt_robotica}
                    </Col>
                  </Row>
                </td>
                <td>
                  {" "}
                  <Row className="text-center">
                    <Col xs={12}>
                      {Number(
                        GET_SUM_T_PAGO(
                          props.dataRPagoD,
                          props.formMatricula.cxcr_anualidad_state === "1"
                            ? "11"
                            : "1",
                          true,
                          data.cxc_id
                        )
                      ).toFixed(2)}
                    </Col>
                    <Col xs={12}>
                      {Number(
                        GET_SUM_T_PAGO(props.dataRPagoD, "5", true, data.cxc_id)
                      ).toFixed(2)}
                    </Col>
                    <Col xs={12}>
                      {Number(
                        GET_SUM_T_PAGO(props.dataRPagoD, "6", true, data.cxc_id)
                      ).toFixed(2)}
                    </Col>
                    <Col xs={12}>
                      {Number(
                        GET_SUM_T_PAGO(props.dataRPagoD, "7", true, data.cxc_id)
                      ).toFixed(2)}
                    </Col>
                  </Row>
                </td>
                <td>
                  {" "}
                  <Row className="text-center">
                    <Col xs={12}>
                      {data.cxc_morostado === "1"
                        ? (
                            Number(
                              props.formMatricula.cxcr_anualidad_state === "1"
                                ? props.formMatricula.cxcr_anualidad
                                : props.formMatricula.cxcr_mensualidad
                            ) *
                              1.1 -
                            Number(
                              GET_SUM_T_PAGO(
                                props.dataRPagoD,
                                props.formMatricula.cxcr_anualidad_state === "1"
                                  ? "11"
                                  : "1",
                                true,
                                data.cxc_id
                              )
                            )
                          ).toFixed(2)
                        : (
                            Number(
                              props.formMatricula.cxcr_anualidad_state === "1"
                                ? props.formMatricula.cxcr_anualidad
                                : props.formMatricula.cxcr_mensualidad
                            ) -
                            Number(
                              GET_SUM_T_PAGO(
                                props.dataRPagoD,
                                props.formMatricula.cxcr_anualidad_state === "1"
                                  ? "11"
                                  : "1",
                                true,
                                data.cxc_id
                              )
                            )
                          ).toFixed(2)}
                    </Col>
                    <Col xs={12}>
                      {props.formMatricula.cxcr_anualidad_state === "1"
                        ? (
                            Number(props.formMonto.mt_a_plataforma) -
                            Number(
                              GET_SUM_T_PAGO(
                                props.dataRPagoD,
                                "5",
                                true,
                                data.cxc_id
                              )
                            )
                          ).toFixed(2)
                        : (
                            Number(props.formMonto.mt_plataforma) -
                            Number(
                              GET_SUM_T_PAGO(
                                props.dataRPagoD,
                                "5",
                                true,
                                data.cxc_id
                              )
                            )
                          ).toFixed(2)}
                    </Col>
                    <Col xs={12}>
                      {props.formMatricula.cxcr_anualidad_state === "1"
                        ? (
                            Number(props.formMonto.mt_a_efisica) -
                            Number(
                              GET_SUM_T_PAGO(
                                props.dataRPagoD,
                                "6",
                                true,
                                data.cxc_id
                              )
                            )
                          ).toFixed(2)
                        : (
                            Number(props.formMonto.mt_efisica) -
                            Number(
                              GET_SUM_T_PAGO(
                                props.dataRPagoD,
                                "6",
                                true,
                                data.cxc_id
                              )
                            )
                          ).toFixed(2)}
                    </Col>
                    <Col xs={12}>
                      {props.formMatricula.cxcr_anualidad_state === "1"
                        ? (
                            Number(props.formMonto.mt_a_robotica) -
                            Number(
                              GET_SUM_T_PAGO(
                                props.dataRPagoD,
                                "7",
                                true,
                                data.cxc_id
                              )
                            )
                          ).toFixed(2)
                        : (
                            Number(props.formMonto.mt_robotica) -
                            Number(
                              GET_SUM_T_PAGO(
                                props.dataRPagoD,
                                "7",
                                true,
                                data.cxc_id
                              )
                            )
                          ).toFixed(2)}
                    </Col>
                  </Row>
                </td>
                <td>
                  <ButtonGroup className="mt-4">
                    <Button
                      color="primary"
                      outline
                      onClick={() => setDebePagar("1", data.cxc_id)}
                      active={data.cxc_stado === "1"}
                    >
                      SI
                    </Button>
                    <Button
                      color="success"
                      outline
                      onClick={() => setDebePagar("2", data.cxc_id)}
                      active={data.cxc_stado === "2"}
                    >
                      NO
                    </Button>
                  </ButtonGroup>
                </td>
                <td>
                  {data.cxc_stado === "1" ? (
                    <ButtonGroup className="mt-4">
                      <Button
                        color="primary"
                        outline
                        onClick={() => setMorosidad("1", data.cxc_id)}
                        active={data.cxc_morostado === "1"}
                      >
                        SI
                      </Button>
                      <Button
                        color="success"
                        outline
                        onClick={() => setMorosidad("2", data.cxc_id)}
                        active={data.cxc_morostado === "2"}
                      >
                        NO
                      </Button>
                    </ButtonGroup>
                  ) : (
                    <ButtonGroup className="mt-4">
                      <Button
                        color="primary"
                        outline
                        disabled
                        active={data.cxc_morostado === "1"}
                      >
                        SI
                      </Button>
                      <Button
                        color="success"
                        outline
                        disabled
                        active={data.cxc_morostado === "2"}
                      >
                        NO
                      </Button>
                    </ButtonGroup>
                  )}
                </td>
                <td>
                  <Row>
                    <Col xs={6}>
                      {data.cxc_stado === "1" ? (
                        <Button
                          color="primary"
                          outline
                          onClick={() =>
                            openAddPago(
                              props.formMatricula.cxcr_anualidad_state === "1"
                                ? "11"
                                : "1",
                              data.cxc_id
                            )
                          }
                          className="mt-2"
                          active={data.cxc_stado === "1"}
                        >
                          {props.formMatricula.cxcr_anualidad_state === "1"
                            ? "Anualidad"
                            : "Mensualidad"}
                        </Button>
                      ) : (
                        <Button
                          color="primary"
                          outline
                          disabled
                          className="mt-2"
                          active={data.cxc_stado === "1"}
                        >
                          {props.formMatricula.cxcr_anualidad_state === "1"
                            ? "Anualidad"
                            : "Mensualidad"}
                        </Button>
                      )}
                    </Col>
                    <Col xs={6}>
                      {data.cxc_stado === "1" ? (
                        <Button
                          color="success"
                          outline
                          onClick={() => openAddPago("5", data.cxc_id)}
                          className="mt-2"
                          active={data.cxc_stado === "1"}
                        >
                          {props.formMatricula.cxcr_anualidad_state === "1"
                            ? "A. Plataforma"
                            : "Plataforma"}
                        </Button>
                      ) : (
                        <Button
                          color="success"
                          outline
                          disabled
                          className="mt-2"
                          active={data.cxc_stado === "1"}
                        >
                          {props.formMatricula.cxcr_anualidad_state === "1"
                            ? "A. Plataforma"
                            : "Plataforma"}
                        </Button>
                      )}
                    </Col>
                    <Col xs={6}>
                      {data.cxc_stado === "1" ? (
                        <Button
                          color="info"
                          outline
                          onClick={() => openAddPago("6", data.cxc_id)}
                          className="mt-2"
                          active={data.cxc_stado === "1"}
                        >
                          {props.formMatricula.cxcr_anualidad_state === "1"
                            ? "A.  Edu. fisica"
                            : " Edu. fisica"}
                        </Button>
                      ) : (
                        <Button
                          color="info"
                          outline
                          disabled
                          className="mt-2"
                          active={data.cxc_stado === "1"}
                        >
                          {props.formMatricula.cxcr_anualidad_state === "1"
                            ? "A.  Edu. fisica"
                            : " Edu. fisica"}
                        </Button>
                      )}
                    </Col>
                    <Col xs={6}>
                      {data.cxc_stado === "1" ? (
                        <Button
                          color="secondary"
                          outline
                          className="mt-2"
                          onClick={() => openAddPago("7", data.cxc_id)}
                          active={data.cxc_stado === "1"}
                        >
                          {props.formMatricula.cxcr_anualidad_state === "1"
                            ? "A.  Robotica"
                            : " Robotica"}
                        </Button>
                      ) : (
                        <Button
                          color="secondary"
                          outline
                          disabled
                          className="mt-2"
                          active={data.cxc_stado === "1"}
                        >
                          {props.formMatricula.cxcr_anualidad_state === "1"
                            ? "A.  Robotica"
                            : " Robotica"}
                        </Button>
                      )}
                    </Col>
                  </Row>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </React.Fragment>
  );
};

const BODY_CUENTAS_REPORT = ({ props }) => {
  return (
    <React.Fragment>
      <Col xs={12} className="mt-3 text-center info">
        <Label>
          {props.cxc_cobrar.length > 8 ? <b>MENSUALIDAD</b> : <b>ANUALIDAD</b>}
        </Label>
      </Col>

      <Table bordered>
        <thead>
          <tr>
            <th className="text-center">
              <b>Tipo de pago</b>
            </th>
            <th className="text-center">
              <b>Monto</b>
            </th>
            <th className="text-center">
              <b>Cancelado</b>
            </th>
            <th className="text-center">
              <b>Por pagar</b>
            </th>
          </tr>
        </thead>
        <tbody>
          {props.cxc_cobrar.map((data, i) => {
            return (
              <tr key={i}>
                <td>
                  <Row className="text-left">
                    <Col xs={12}>
                      {props.formMatricula.cxcr_anualidad_state === "1" ? (
                        <b>Anualidad</b>
                      ) : (
                        <b>Cuota N{data.cxc_cuota}</b>
                      )}
                    </Col>
                    <Col xs={12}>Plataforma</Col>
                    <Col xs={12}>Edu. fisica</Col>
                    <Col xs={12}>Robótica</Col>
                  </Row>
                </td>
                <td>
                  {" "}
                  <Row className="text-center">
                    <Col xs={12}>
                      {props.formMatricula.cxcr_anualidad_state === "1" ? (
                        props.formMatricula.cxcr_anualidad
                      ) : data.cxc_morostado === "1" ? (
                        <b>
                          {(
                            Number(props.formMatricula.cxcr_mensualidad) * 1.1
                          ).toFixed(2)}
                        </b>
                      ) : (
                        props.formMatricula.cxcr_mensualidad
                      )}
                    </Col>
                    <Col xs={12}>
                      {props.formMatricula.cxcr_anualidad_state === "1"
                        ? props.formMonto.mt_a_plataforma
                        : props.formMonto.mt_plataforma}
                    </Col>
                    <Col xs={12}>
                      {props.formMatricula.cxcr_anualidad_state === "1"
                        ? props.formMonto.mt_a_efisica
                        : props.formMonto.mt_efisica}
                    </Col>
                    <Col xs={12}>
                      {props.formMatricula.cxcr_anualidad_state === "1"
                        ? props.formMonto.mt_a_robotica
                        : props.formMonto.mt_robotica}
                    </Col>
                  </Row>
                </td>
                <td>
                  {" "}
                  <Row className="text-center">
                    <Col xs={12}>
                      {Number(
                        GET_SUM_T_PAGO(
                          props.dataRPagoD,
                          props.formMatricula.cxcr_anualidad_state === "1"
                            ? "11"
                            : "1",
                          true,
                          data.cxc_id
                        )
                      ).toFixed(2)}
                    </Col>
                    <Col xs={12}>
                      {Number(
                        GET_SUM_T_PAGO(props.dataRPagoD, "5", true, data.cxc_id)
                      ).toFixed(2)}
                    </Col>
                    <Col xs={12}>
                      {Number(
                        GET_SUM_T_PAGO(props.dataRPagoD, "6", true, data.cxc_id)
                      ).toFixed(2)}
                    </Col>
                    <Col xs={12}>
                      {Number(
                        GET_SUM_T_PAGO(props.dataRPagoD, "7", true, data.cxc_id)
                      ).toFixed(2)}
                    </Col>
                  </Row>
                </td>
                <td>
                  {" "}
                  <Row className="text-center">
                    <Col xs={12}>
                      {data.cxc_morostado === "1" ? (
                        <React.Fragment>
                          {props.formMatricula.cxcr_anualidad_state === "1"
                            ? (
                                Number(props.formMatricula.cxcr_anualidad) *
                                  1.1 -
                                Number(
                                  GET_SUM_T_PAGO(
                                    props.dataRPagoD,
                                    "11",
                                    true,
                                    data.cxc_id
                                  )
                                )
                              ).toFixed(2)
                            : (
                                Number(props.formMatricula.cxcr_mensualidad) *
                                  1.1 -
                                Number(
                                  GET_SUM_T_PAGO(
                                    props.dataRPagoD,
                                    "1",
                                    true,
                                    data.cxc_id
                                  )
                                )
                              ).toFixed(2)}
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          {props.formMatricula.cxcr_anualidad_state === "1"
                            ? (
                                Number(props.formMatricula.cxcr_anualidad) -
                                Number(
                                  GET_SUM_T_PAGO(
                                    props.dataRPagoD,
                                    "11",
                                    true,
                                    data.cxc_id
                                  )
                                )
                              ).toFixed(2)
                            : (
                                Number(props.formMatricula.cxcr_mensualidad) -
                                Number(
                                  GET_SUM_T_PAGO(
                                    props.dataRPagoD,
                                    "1",
                                    true,
                                    data.cxc_id
                                  )
                                )
                              ).toFixed(2)}
                        </React.Fragment>
                      )}
                    </Col>
                    <Col xs={12}>
                      {props.formMatricula.cxcr_anualidad_state === "1"
                        ? (
                            Number(props.formMonto.mt_a_plataforma) -
                            Number(
                              GET_SUM_T_PAGO(
                                props.dataRPagoD,
                                "5",
                                true,
                                data.cxc_id
                              )
                            )
                          ).toFixed(2)
                        : (
                            Number(props.formMonto.mt_plataforma) -
                            Number(
                              GET_SUM_T_PAGO(
                                props.dataRPagoD,
                                "5",
                                true,
                                data.cxc_id
                              )
                            )
                          ).toFixed(2)}
                    </Col>
                    <Col xs={12}>
                      {props.formMatricula.cxcr_anualidad_state === "1"
                        ? (
                            Number(props.formMonto.mt_a_efisica) -
                            Number(
                              GET_SUM_T_PAGO(
                                props.dataRPagoD,
                                "6",
                                true,
                                data.cxc_id
                              )
                            )
                          ).toFixed(2)
                        : (
                            Number(props.formMonto.mt_efisica) -
                            Number(
                              GET_SUM_T_PAGO(
                                props.dataRPagoD,
                                "5",
                                true,
                                data.cxc_id
                              )
                            )
                          ).toFixed(2)}
                    </Col>
                    <Col xs={12}>
                      {props.formMatricula.cxcr_anualidad_state === "1"
                        ? (
                            Number(props.formMonto.mt_a_robotica) -
                            Number(
                              GET_SUM_T_PAGO(
                                props.dataRPagoD,
                                "7",
                                true,
                                data.cxc_id
                              )
                            )
                          ).toFixed(2)
                        : (
                            Number(props.formMonto.mt_robotica) -
                            Number(
                              GET_SUM_T_PAGO(
                                props.dataRPagoD,
                                "5",
                                true,
                                data.cxc_id
                              )
                            )
                          ).toFixed(2)}
                    </Col>
                  </Row>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </React.Fragment>
  );
};

const GET_SUM_T_PAGO = (props, tpago, cxc, cxc_id) => {
  var sum = 0;
  if (cxc) {
    props.map((data, i) => {
      if (data.rpd_tpago === tpago && data.rpd_cxc === cxc_id) {
        sum = Number(sum) + Number(data.rpd_monto);
      }
      return null;
    });
    return sum;
  } else {
    props.map((data, i) => {
      if (data.rpd_tpago === tpago) {
        sum = Number(sum) + Number(data.rpd_monto);
      }
      return null;
    });
  }

  return sum;
};

const GET_PROMF_NORMAL = (dataNote, dataA) => {
  var promCount = 0;
  var prom = 0;
  dataNote.map((data, i) => {
    if (dataA.ar_id === data.ar_id && dataNote[0].as_id === data.as_id) {
      promCount = Number(promCount) + 1;
      prom = Number(prom) + Number(data.not_score);
    }
    return null;
  });
  return TruncarNotas(Number(prom / promCount), 1);
};
const GET_PROMF_DIVIDIDO = (dataNote) => {
  var prom = 0;
  var aprec = 0;
  var notaET = 0;
  var notaD = 0;
  var promCount = 0;
  var aprecCount = 0;
  var notaDCount = 0;
  var promF = 0;
  dataNote.map((sum, i) => {
    if (sum.di_typeassignment === "3") {
      aprec = Number(aprec) + Number(sum.not_score);
      aprecCount = Number(aprecCount) + 1;
    } else if (sum.di_typeassignment === "6") {
      notaET = Number(sum.not_score);
    } else {
      notaD = Number(notaD) + Number(sum.not_score);
      notaDCount = Number(notaDCount) + 1;
    }
    promCount = Number(promCount) + 1;

    prom = Number(prom) + Number(sum.not_score);

    return null;
  });
  promF = aprec / aprecCount + notaD / notaDCount + notaET;
  return TruncarNotas(Number(promF / 3), 1);
};
export {
  GET_PROMF_NORMAL,
  GET_PROMF_DIVIDIDO,
  GET_SUM_T_PAGO,
  BODY_CUENTAS_REPORT,
  BODY_CUENTAS,
  TruncarNotas,
  ImageViewerAgenda,
  NOTE_EDIT_TAREA_LITERAL,
  NOTA_VER_TAREA_LITERAL,
  NOTA_PROMEDIO_NORMAL,
  NOTA_PROMEDIO_LITERAL,
  AREA_LIST,
  NOTE_EDIT,
  NOTA_PROMEDIO_DIVIDO,
  getHabitosAptitudes,
  validateTokenStorage,
  PAYMENT_ACCOUNT_STUDENT,
  PAYMENT_ACCOUNT,
  TRIMESTRE_HANDLER,
  FIND_DESC,
  MESSAGE_CHAT_CONTAINER_TEACHER,
  GET_DATE_MONTH_DAY,
  GET_WEEK_START_END,
  ImageViewerAnnouncement,
  ScheduleTeacherReview,
  Announcement,
  ordenarAsc,
  TeacherSchedule,
  Schedule,
  SchedulePrint,
  Messagess,
  Ratings,
  Payment,
  ProfilePanel,
  PaginationHeaderYear,
  PaginationHeader,
  HOUR_CLASS,
  MESSAGE_CHAT_CONTAINER,
  ProfilePanelTeacher,
  ScheduleTeacherHistory,
  PaginationHeaderStudentAgenda,
  HOUR_BODY_PRINT,
};
